import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const resources = {
fr:{
  "translation":{
    "incorrect":"Incorrect",
    "phoneplaceholder":"Téléphone...",
    "already_subscriber":"Déjà abonné",
    "play":"JOUER",
    "landing":{
      "verify":"VÉRIFIER",
      "continue":"CONTINUER",
      "title":"Gagne jusqu’à 2000 Dinars chaque semaine ! Choisis les meilleurs joueurs, crée ton équipe de rêve en Football Fantasy et tente de décrocher les récompenses hebdomadaires !",
      "pricepoint":"Trois jours gratuit puis 0.7 DT/jour (Renouvellement automatique)",
    },
    "header":{
      "about":"À propos",
      "createteam":"Créer une équipe",
      "faq":"FAQ"
    },
    "about":{
      "title":"Vivez le football comme jamais auparavant avec Football Fantansy !",
      "teamwork":"Jouez votre favori <br/> Ligue de football",
      "friend":"Rivaliser avec des amis",
      "badge":"Gagnez des récompenses fantastiques",
    },
    "createteam":{
      "title":"Créez votre équipe de quatre manières simples",
      "wayONE":"Sélectionnez la ligue ou le tournoi souhaité pour jouer",
      "wayTWO":"Sélectionnez les joueurs en cliquant sur le bouton + sur chaque position",
      "wayTHREE":"Choisissez votre capitaine (en doublant ses points) et votre vice-capitaine",
      "wayFOUR":"Marquez des points et participez à des matchs réels en fonction des performances des joueurs."
    },
    "faq":{
      "title":"Des questions ? Des réponses.",
      "question1":"Comment démarrer avec le football fantasy ?",
      "answer1":"Avec Fantasy Football Eleven, vous pouvez choisir votre équipe idéale de 11 joueurs issus des meilleurs championnats et tournois du monde, tout au long de l'année. Marquez des points et affrontez les joueurs sélectionnés en fonction de leurs performances réelles lors de matchs réels.",
      "question2":"Que puis-je gagner en jouant au Football Fantasy ?",
      "answer2":"Prix ​​hebdomadaires, le cas échéant",
      "question3":"Puis-je jouer avec mes amis ?",
      "answer3":"Bien sûr, les amis peuvent s'abonner et rivaliser avec eux dans chaque classement de ligue.",
      "question4":"Quels tournois de football sont disponibles sur Football Fantasy ?",
      "answer4":"Nous couvrons les meilleurs tournois mondiaux tels que : la Coupe du monde, la Premier League anglaise, la Ligue espagnole, la Pro League saoudienne, la Coupe d'Europe, la Coupe d'Afrique des Nations et bien plus encore.",

    },
   "footer": {
    "termsandcondition":"Termes et Conditions",
    "termscondition":`<html xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office"
xmlns:w="urn:schemas-microsoft-com:office:word"
xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"
xmlns="http://www.w3.org/TR/REC-html40">

<head>
<meta http-equiv=Content-Type content="text/html; charset=windows-1252">
<meta name=ProgId content=Word.Document>
<meta name=Generator content="Microsoft Word 15">
<meta name=Originator content="Microsoft Word 15">
<link rel=File-List href="terms_condition_files/filelist.xml">
<link rel=Edit-Time-Data href="terms_condition_files/editdata.mso">
<!--[if !mso]>
<style>
v\:* {behavior:url(#default#VML);}
o\:* {behavior:url(#default#VML);}
w\:* {behavior:url(#default#VML);}
.shape {behavior:url(#default#VML);}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:DocumentProperties>
  <o:Author>Slim Beji</o:Author>
  <o:Template>Normal</o:Template>
  <o:LastAuthor>Tala Alkhatib</o:LastAuthor>
  <o:Revision>2</o:Revision>
  <o:TotalTime>2</o:TotalTime>
  <o:Created>2025-09-24T12:00:00Z</o:Created>
  <o:LastSaved>2025-09-24T12:00:00Z</o:LastSaved>
  <o:Pages>7</o:Pages>
  <o:Words>2727</o:Words>
  <o:Characters>15549</o:Characters>
  <o:Lines>129</o:Lines>
  <o:Paragraphs>36</o:Paragraphs>
  <o:CharactersWithSpaces>18240</o:CharactersWithSpaces>
  <o:Version>16.00</o:Version>
 </o:DocumentProperties>
 <o:OfficeDocumentSettings>
  <o:AllowPNG/>
 </o:OfficeDocumentSettings>
</xml><![endif]-->
<link rel=themeData href="terms_condition_files/themedata.thmx">
<link rel=colorSchemeMapping href="terms_condition_files/colorschememapping.xml">
<!--[if gte mso 9]><xml>
 <w:WordDocument>
  <w:SpellingState>Clean</w:SpellingState>
  <w:GrammarState>Clean</w:GrammarState>
  <w:TrackMoves>false</w:TrackMoves>
  <w:TrackFormatting/>
  <w:HyphenationZone>21</w:HyphenationZone>
  <w:PunctuationKerning/>
  <w:DrawingGridHorizontalSpacing>6 pt</w:DrawingGridHorizontalSpacing>
  <w:DrawingGridVerticalSpacing>8.15 pt</w:DrawingGridVerticalSpacing>
  <w:DisplayHorizontalDrawingGridEvery>2</w:DisplayHorizontalDrawingGridEvery>
  <w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery>
  <w:ValidateAgainstSchemas/>
  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>
  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>
  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>
  <w:DoNotPromoteQF/>
  <w:LidThemeOther>FR</w:LidThemeOther>
  <w:LidThemeAsian>X-NONE</w:LidThemeAsian>
  <w:LidThemeComplexScript>AR-SA</w:LidThemeComplexScript>
  <w:Compatibility>
   <w:BreakWrappedTables/>
   <w:SnapToGridInCell/>
   <w:WrapTextWithPunct/>
   <w:UseAsianBreakRules/>
   <w:DontGrowAutofit/>
   <w:SplitPgBreakAndParaMark/>
   <w:EnableOpenTypeKerning/>
   <w:DontFlipMirrorIndents/>
   <w:OverrideTableStyleHps/>
  </w:Compatibility>
  <m:mathPr>
   <m:mathFont m:val="Cambria Math"/>
   <m:brkBin m:val="before"/>
   <m:brkBinSub m:val="&#45;-"/>
   <m:smallFrac m:val="off"/>
   <m:dispDef/>
   <m:lMargin m:val="0"/>
   <m:rMargin m:val="0"/>
   <m:defJc m:val="centerGroup"/>
   <m:wrapIndent m:val="1440"/>
   <m:intLim m:val="subSup"/>
   <m:naryLim m:val="undOvr"/>
  </m:mathPr></w:WordDocument>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="false"
  DefSemiHidden="false" DefQFormat="false" DefPriority="99"
  LatentStyleCount="376">
  <w:LsdException Locked="false" Priority="0" QFormat="true" Name="Normal"/>
  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 1"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 2"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 3"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 4"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 5"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 6"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 7"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 8"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 9"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 1"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 2"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 3"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 4"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 5"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 6"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 7"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 8"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="header"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footer"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index heading"/>
  <w:LsdException Locked="false" Priority="35" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="caption"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of figures"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope return"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="line number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="page number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of authorities"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="macro"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="toa heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 5"/>
  <w:LsdException Locked="false" Priority="10" QFormat="true" Name="Title"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Closing"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Signature"/>
  <w:LsdException Locked="false" Priority="1" SemiHidden="true"
   UnhideWhenUsed="true" Name="Default Paragraph Font"/>
  <w:LsdException Locked="false" Priority="1" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="Body Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Message Header"/>
  <w:LsdException Locked="false" Priority="11" QFormat="true" Name="Subtitle"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Salutation"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Date"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Note Heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Block Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="FollowedHyperlink"/>
  <w:LsdException Locked="false" Priority="22" QFormat="true" Name="Strong"/>
  <w:LsdException Locked="false" Priority="20" QFormat="true" Name="Emphasis"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Document Map"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Plain Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="E-mail Signature"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Top of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Bottom of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal (Web)"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Acronym"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Cite"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Code"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Definition"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Keyboard"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Preformatted"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Sample"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Typewriter"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Variable"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Table"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation subject"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="No List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Contemporary"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Elegant"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Professional"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Balloon Text"/>
  <w:LsdException Locked="false" Priority="39" Name="Table Grid"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Theme"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Placeholder Text"/>
  <w:LsdException Locked="false" Priority="1" QFormat="true" Name="No Spacing"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 1"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 1"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Revision"/>
  <w:LsdException Locked="false" Priority="1" QFormat="true"
   Name="List Paragraph"/>
  <w:LsdException Locked="false" Priority="29" QFormat="true" Name="Quote"/>
  <w:LsdException Locked="false" Priority="30" QFormat="true"
   Name="Intense Quote"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 1"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 1"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 2"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 2"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 2"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 3"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 3"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 3"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 4"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 4"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 4"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 5"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 5"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 5"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 6"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 6"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 6"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="19" QFormat="true"
   Name="Subtle Emphasis"/>
  <w:LsdException Locked="false" Priority="21" QFormat="true"
   Name="Intense Emphasis"/>
  <w:LsdException Locked="false" Priority="31" QFormat="true"
   Name="Subtle Reference"/>
  <w:LsdException Locked="false" Priority="32" QFormat="true"
   Name="Intense Reference"/>
  <w:LsdException Locked="false" Priority="33" QFormat="true" Name="Book Title"/>
  <w:LsdException Locked="false" Priority="37" SemiHidden="true"
   UnhideWhenUsed="true" Name="Bibliography"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="TOC Heading"/>
  <w:LsdException Locked="false" Priority="41" Name="Plain Table 1"/>
  <w:LsdException Locked="false" Priority="42" Name="Plain Table 2"/>
  <w:LsdException Locked="false" Priority="43" Name="Plain Table 3"/>
  <w:LsdException Locked="false" Priority="44" Name="Plain Table 4"/>
  <w:LsdException Locked="false" Priority="45" Name="Plain Table 5"/>
  <w:LsdException Locked="false" Priority="40" Name="Grid Table Light"/>
  <w:LsdException Locked="false" Priority="46" Name="Grid Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="Grid Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="Grid Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="46" Name="List Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="List Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="List Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hashtag"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Unresolved Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Link"/>
 </w:LatentStyles>
</xml><![endif]-->
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:Wingdings;
	panose-1:5 0 0 0 0 0 0 0 0 0;
	mso-font-charset:2;
	mso-generic-font-family:auto;
	mso-font-pitch:variable;
	mso-font-signature:0 268435456 0 0 -2147483648 0;}
@font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;
	mso-font-charset:0;
	mso-generic-font-family:roman;
	mso-font-pitch:variable;
	mso-font-signature:-536869121 1107305727 33554432 0 415 0;}
@font-face
	{font-family:"Trebuchet MS";
	panose-1:2 11 6 3 2 2 2 2 2 4;
	mso-font-alt:"Trebuchet MS";
	mso-font-charset:0;
	mso-generic-font-family:swiss;
	mso-font-pitch:variable;
	mso-font-signature:1671 0 0 0 159 0;}
@font-face
	{font-family:Aptos;
	mso-font-charset:0;
	mso-generic-font-family:swiss;
	mso-font-pitch:variable;
	mso-font-signature:536871559 3 0 0 415 0;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-parent:"";
	margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
h1
	{mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Heading 1 Char";
	mso-style-next:Normal;
	margin-top:.25in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:1;
	text-autospace:none;
	font-size:20.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-font-kerning:0pt;
	mso-ansi-language:FR;
	font-weight:normal;}
h2
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 2 Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:2;
	text-autospace:none;
	font-size:16.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h3
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 3 Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:3;
	text-autospace:none;
	font-size:14.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h4
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 4 Char";
	mso-style-next:Normal;
	margin-top:4.0pt;
	margin-right:0in;
	margin-bottom:2.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:4;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;
	font-style:italic;}
h5
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 5 Char";
	mso-style-next:Normal;
	margin-top:4.0pt;
	margin-right:0in;
	margin-bottom:2.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:5;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h6
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 6 Char";
	mso-style-next:Normal;
	margin-top:2.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:6;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	mso-ansi-language:FR;
	font-weight:normal;
	font-style:italic;}
p.MsoHeading7, li.MsoHeading7, div.MsoHeading7
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 7 Char";
	mso-style-next:Normal;
	margin-top:2.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:7;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	mso-ansi-language:FR;}
p.MsoHeading8, li.MsoHeading8, div.MsoHeading8
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 8 Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:8;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	mso-ansi-language:FR;
	font-style:italic;}
p.MsoHeading9, li.MsoHeading9, div.MsoHeading9
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 9 Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:9;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	mso-ansi-language:FR;}
p.MsoHeader, li.MsoHeader, div.MsoHeader
	{mso-style-priority:99;
	mso-style-link:"Header Char";
	margin:0in;
	mso-pagination:none;
	tab-stops:center 3.15in right 6.3in;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoFooter, li.MsoFooter, div.MsoFooter
	{mso-style-priority:99;
	mso-style-link:"Footer Char";
	margin:0in;
	mso-pagination:none;
	tab-stops:center 3.15in right 6.3in;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoTitle, li.MsoTitle, div.MsoTitle
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpFirst, li.MsoTitleCxSpFirst, div.MsoTitleCxSpFirst
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpMiddle, li.MsoTitleCxSpMiddle, div.MsoTitleCxSpMiddle
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpLast, li.MsoTitleCxSpLast, div.MsoTitleCxSpLast
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoBodyText, li.MsoBodyText, div.MsoBodyText
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Body Text Char";
	margin-top:.05pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:28.3pt;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoSubtitle, li.MsoSubtitle, div.MsoSubtitle
	{mso-style-priority:11;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Subtitle Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:14.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	letter-spacing:.75pt;
	mso-ansi-language:FR;}
a:link, span.MsoHyperlink
	{mso-style-priority:99;
	color:#467886;
	mso-themecolor:hyperlink;
	text-decoration:underline;
	text-underline:single;}
a:visited, span.MsoHyperlinkFollowed
	{mso-style-noshow:yes;
	mso-style-priority:99;
	color:#96607D;
	mso-themecolor:followedhyperlink;
	text-decoration:underline;
	text-underline:single;}
p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoQuote, li.MsoQuote, div.MsoQuote
	{mso-style-priority:29;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Quote Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	text-align:center;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	color:#404040;
	mso-themecolor:text1;
	mso-themetint:191;
	mso-ansi-language:FR;
	font-style:italic;}
p.MsoIntenseQuote, li.MsoIntenseQuote, div.MsoIntenseQuote
	{mso-style-priority:30;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Intense Quote Char";
	mso-style-next:Normal;
	margin-top:.25in;
	margin-right:.6in;
	margin-bottom:.25in;
	margin-left:.6in;
	text-align:center;
	mso-pagination:none;
	text-autospace:none;
	border:none;
	mso-border-top-alt:solid #0F4761 .5pt;
	mso-border-top-themecolor:accent1;
	mso-border-top-themeshade:191;
	mso-border-bottom-alt:solid #0F4761 .5pt;
	mso-border-bottom-themecolor:accent1;
	mso-border-bottom-themeshade:191;
	padding:0in;
	mso-padding-alt:10.0pt 0in 10.0pt 0in;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-style:italic;}
span.MsoIntenseEmphasis
	{mso-style-priority:21;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.MsoIntenseReference
	{mso-style-priority:32;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	font-variant:small-caps;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	letter-spacing:.25pt;
	font-weight:bold;}
span.Heading1Char
	{mso-style-name:"Heading 1 Char";
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 1";
	mso-ansi-font-size:20.0pt;
	mso-bidi-font-size:20.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading2Char
	{mso-style-name:"Heading 2 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 2";
	mso-ansi-font-size:16.0pt;
	mso-bidi-font-size:16.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading3Char
	{mso-style-name:"Heading 3 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 3";
	mso-ansi-font-size:14.0pt;
	mso-bidi-font-size:14.0pt;
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading4Char
	{mso-style-name:"Heading 4 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 4";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.Heading5Char
	{mso-style-name:"Heading 5 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 5";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading6Char
	{mso-style-name:"Heading 6 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 6";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	font-style:italic;}
span.Heading7Char
	{mso-style-name:"Heading 7 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 7";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;}
span.Heading8Char
	{mso-style-name:"Heading 8 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 8";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	font-style:italic;}
span.Heading9Char
	{mso-style-name:"Heading 9 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 9";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;}
span.TitleChar
	{mso-style-name:"Title Char";
	mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Title;
	mso-ansi-font-size:28.0pt;
	mso-bidi-font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;}
span.SubtitleChar
	{mso-style-name:"Subtitle Char";
	mso-style-priority:11;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Subtitle;
	mso-ansi-font-size:14.0pt;
	mso-bidi-font-size:14.0pt;
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	letter-spacing:.75pt;}
span.QuoteChar
	{mso-style-name:"Quote Char";
	mso-style-priority:29;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Quote;
	color:#404040;
	mso-themecolor:text1;
	mso-themetint:191;
	font-style:italic;}
span.IntenseQuoteChar
	{mso-style-name:"Intense Quote Char";
	mso-style-priority:30;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Intense Quote";
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.BodyTextChar
	{mso-style-name:"Body Text Char";
	mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Body Text";
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
p.TableParagraph, li.TableParagraph, div.TableParagraph
	{mso-style-name:"Table Paragraph";
	mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	margin-top:5.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:1.0pt;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
span.HeaderChar
	{mso-style-name:"Header Char";
	mso-style-priority:99;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Header;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
span.FooterChar
	{mso-style-name:"Footer Char";
	mso-style-priority:99;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Footer;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
span.SpellE
	{mso-style-name:"";
	mso-spl-e:yes;}
span.GramE
	{mso-style-name:"";
	mso-gram-e:yes;}
.MsoChpDefault
	{mso-style-type:export-only;
	mso-default-props:yes;
	font-size:12.0pt;
	mso-ansi-font-size:12.0pt;
	mso-bidi-font-size:12.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-fareast-font-family:Aptos;
	mso-fareast-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;
	mso-bidi-font-family:Arial;
	mso-bidi-theme-font:minor-bidi;
	mso-ansi-language:FR;}
.MsoPapDefault
	{mso-style-type:export-only;
	margin-bottom:8.0pt;
	line-height:115%;}
 /* Page Definitions */
 @page
	{mso-footnote-separator:url("terms_condition_files/header.htm") fs;
	mso-footnote-continuation-separator:url("terms_condition_files/header.htm") fcs;
	mso-endnote-separator:url("terms_condition_files/header.htm") es;
	mso-endnote-continuation-separator:url("terms_condition_files/header.htm") ecs;}
@page WordSection1
	{size:595.5pt 842.0pt;
	margin:66.0pt 42.5pt 47.0pt 42.5pt;
	mso-header-margin:0in;
	mso-footer-margin:37.4pt;
	border:solid #747474 1.5pt;
	padding:20.0pt 16.0pt 23.0pt 14.0pt;
	mso-footer:url("terms_condition_files/header.htm") f1;
	mso-paper-source:0;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 @list l0
	{mso-list-id:65345066;
	mso-list-type:hybrid;
	mso-list-template-ids:-2132766678 481063848 67895299 67895301 67895297 67895299 67895301 67895297 67895299 67895301;}
@list l0:level1
	{mso-level-start-at:4;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:46.3pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";}
@list l0:level2
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level3
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:118.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l0:level4
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:154.3pt;
	text-indent:-.25in;
	font-family:Symbol;}
@list l0:level5
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:190.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level6
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:226.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l0:level7
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:262.3pt;
	text-indent:-.25in;
	font-family:Symbol;}
@list l0:level8
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:298.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level9
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:334.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l1
	{mso-list-id:75252490;
	mso-list-template-ids:581487838;}
@list l1:level1
	{mso-level-start-at:4;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level2
	{mso-level-start-at:3;
	mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-20.4pt;
	mso-ansi-font-size:12.0pt;
	mso-bidi-font-size:12.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l1:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:163.15pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:212.75pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:262.35pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:311.95pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:361.5pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:411.1pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2
	{mso-list-id:144013986;
	mso-list-type:hybrid;
	mso-list-template-ids:-83202504 -375365978 -1949528154 1340512296 -1238759444 765499220 -535024728 299673496 410431232 392327426;}
@list l2:level1
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-.25in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l2:level2
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:100.3pt;
	text-indent:-.5in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l2:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:145.55pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:191.15pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:236.75pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:282.35pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:327.95pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:373.5pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:419.1pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3
	{mso-list-id:302586870;
	mso-list-type:hybrid;
	mso-list-template-ids:-855719610 1081741136 -533941608 593134594 -857947172 1322008396 -1179731494 1475742350 1240379596 357714874;}
@list l3:level1
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:34.65pt;
	text-indent:-6.4pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l3:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.5pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:130.05pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:177.55pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:225.1pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:272.65pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:320.15pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:367.7pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:415.25pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l4
	{mso-list-id:845291412;
	mso-list-type:hybrid;
	mso-list-template-ids:1133918808 481063848 67895299 67895301 67895297 67895299 67895301 67895297 67895299 67895301;}
@list l4:level1
	{mso-level-start-at:4;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:53.45pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";}
@list l4:level2
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level3
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l4:level4
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Symbol;}
@list l4:level5
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level6
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l4:level7
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Symbol;}
@list l4:level8
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level9
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l5
	{mso-list-id:951015993;
	mso-list-type:hybrid;
	mso-list-template-ids:40894972 -2034321484 519206196 -569575802 1051516998 -1960307128 1359479974 -1627613710 229526434 506101588;}
@list l5:level1
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-.25in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l5:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:108.6pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:153.25pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:197.85pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:242.5pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:287.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:331.75pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:376.4pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:421.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6
	{mso-list-id:1119107937;
	mso-list-template-ids:1536082450;}
@list l6:level1
	{mso-level-start-at:4;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level2
	{mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level3
	{mso-level-start-at:5;
	mso-level-text:"%1\.%2\.%3";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l6:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:197.85pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:242.5pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:287.15pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:331.75pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:376.4pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:421.05pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7
	{mso-list-id:1556769011;
	mso-list-type:hybrid;
	mso-list-template-ids:231362116 76955280 -1872831298 -78199902 -1493786652 1900572830 -1114967158 -1342291872 899712228 -982057908;}
@list l7:level1
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:100.3pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:124%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:141.0pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:182.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:223.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:264.1pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:305.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:346.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:387.2pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:428.25pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8
	{mso-list-id:1658344737;
	mso-list-template-ids:511499126;}
@list l8:level1
	{mso-level-start-at:6;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level2
	{mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l8:level3
	{mso-level-number-format:alpha-upper;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:136.3pt;
	text-indent:-.5in;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:bold;
	mso-bidi-font-weight:bold;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l8:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:219.15pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:260.75pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:302.35pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:343.95pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:385.5pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:427.1pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l9
	{mso-list-id:1742099668;
	mso-list-type:hybrid;
	mso-list-template-ids:-956401252 1822617726 67895321 67895323 67895311 67895321 67895323 67895311 67895321 67895323;}
@list l9:level1
	{mso-level-start-at:3;
	mso-level-text:%1-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.3pt;
	text-indent:-.25in;}
@list l9:level2
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:118.3pt;
	text-indent:-.25in;}
@list l9:level3
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:154.3pt;
	text-indent:-9.0pt;}
@list l9:level4
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:190.3pt;
	text-indent:-.25in;}
@list l9:level5
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:226.3pt;
	text-indent:-.25in;}
@list l9:level6
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:262.3pt;
	text-indent:-9.0pt;}
@list l9:level7
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:298.3pt;
	text-indent:-.25in;}
@list l9:level8
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:334.3pt;
	text-indent:-.25in;}
@list l9:level9
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:370.3pt;
	text-indent:-9.0pt;}
ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>
<!--[if gte mso 10]>
<style>
 /* Style Definitions */
 table.MsoNormalTable
	{mso-style-name:"Table Normal";
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-noshow:yes;
	mso-style-priority:99;
	mso-style-parent:"";
	mso-padding-alt:0in 5.4pt 0in 5.4pt;
	mso-para-margin-top:0in;
	mso-para-margin-right:0in;
	mso-para-margin-bottom:8.0pt;
	mso-para-margin-left:0in;
	line-height:115%;
	mso-pagination:widow-orphan;
	font-size:12.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;
	mso-font-kerning:1.0pt;
	mso-ligatures:standardcontextual;
	mso-ansi-language:FR;}
table.TableNormal1
	{mso-style-name:"Table Normal1";
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-noshow:yes;
	mso-style-priority:2;
	mso-style-qformat:yes;
	mso-style-parent:"";
	mso-padding-alt:0in 0in 0in 0in;
	mso-para-margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:shapedefaults v:ext="edit" spidmax="1027"/>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <o:shapelayout v:ext="edit">
  <o:idmap v:ext="edit" data="1"/>
 </o:shapelayout></xml><![endif]-->
</head>

<body lang=EN-US link="#467886" vlink="#96607D" style='tab-interval:35.4pt;
word-wrap:break-word'>

<div class=WordSection1>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>PR SENTATION</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ET</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>PRINCIPE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>DU</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>JEU<o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Football</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>plateforme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>permet</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>aux</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>utilisateurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jouer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>ligne</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>rejoindre
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>un<span style='letter-spacing:-1.0pt'> </span>Championnat<span
style='letter-spacing:-1.0pt'> </span>en<span style='letter-spacing:-1.0pt'> </span>s lectionnant<span
style='letter-spacing:-.9pt'> </span>11<span style='letter-spacing:-.95pt'> </span>footballeurs<span
style='letter-spacing:-.85pt'> </span> voluant<span style='letter-spacing:-1.0pt'>
</span>dans<span style='letter-spacing:-.85pt'> </span>la<span
style='letter-spacing:-1.0pt'> </span>ligue<span style='letter-spacing:-.75pt'>
</span>Choisie,<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l utilisateur</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>collecte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>points</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fonction</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>performances</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r elles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>joueurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>concourt<span style='letter-spacing:2.0pt'> </span>au
fil<span style='letter-spacing:-.05pt'> </span>des<span style='letter-spacing:
-.2pt'> </span>matchs disput s.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Football<span style='letter-spacing:-.75pt'> </span>fantasy<span
style='letter-spacing:-.95pt'> </span>est<span style='letter-spacing:-.9pt'> </span>un<span
style='letter-spacing:-.85pt'> </span>jeu<span style='letter-spacing:1.95pt'> </span>d'abonnement<span
style='letter-spacing:-.9pt'> </span>Web<span style='letter-spacing:-1.0pt'> </span>disponible<span
style='letter-spacing:-.85pt'> </span>pour<span style='letter-spacing:-.8pt'> </span>les<span
style='letter-spacing:-.9pt'> </span>abonn s<span style='letter-spacing:-.9pt'>
</span>mobiles<span style='letter-spacing:-.6pt'> </span>en <span
style='letter-spacing:-.2pt'>Tunisie.<o:p></o:p></span></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ARTICLE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>3</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DATE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ET</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DUREE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DU</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>JEU<o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-indent:
2.4pt'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><b style='mso-bidi-font-weight:normal'><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Football</span></b><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fantasy</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span></b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>est</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>accessible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>moment</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pendant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>p riode</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du
<b><span style='color:black'>25/09/2025</span></b></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>partir</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.05pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>00.00.00</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>se</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>termine</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>23/12</span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>/2025</span></b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>23.59.59.</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:66.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dur e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>totale</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:.2pt'> </span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>90</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.3pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jours<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:66.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>ARTICLE<span style='letter-spacing:-1.2pt'> </span>4<span
style='letter-spacing:-1.05pt'> </span>:<span style='letter-spacing:-1.15pt'> </span>MODE<span
style='letter-spacing:-1.15pt'> </span>DE<span style='letter-spacing:-1.05pt'> </span><span
style='letter-spacing:-.1pt'>PARTICIPATION<o:p></o:p></span></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ouvert</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tous</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>abonn s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Tunisie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sauf</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>celles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>cit es</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'article
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>5 du pr sent r glement.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>obligation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d achat.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>service</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disponible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>canaux,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>comme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d crit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ci-
</span><span class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>dessous:</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>En<span style='letter-spacing:-.45pt'> </span>composant<span
style='letter-spacing:-.4pt'> </span>le<span style='letter-spacing:-.35pt'> </span>code<span
style='letter-spacing:-.35pt'> </span>USSD<span style='letter-spacing:-.4pt'> </span><b>*898*2#<o:p></o:p></b></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>En</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>envoyant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>contenant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mot</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>cl </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>  &nbsp;</span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Fantasy</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>&nbsp; </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>85881</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>En</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>acc dant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l URL</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR><a href="https://tt.ffeleven.com/"><span style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.2pt'>https://tt.ffeleven.com</span></a></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='tab-stops:100.3pt'><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Une</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fois</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'inscription</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>r ussie,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>clients</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevront</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>message</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>bienvenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>m me
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>num ro<span style='letter-spacing:-.9pt'> </span>court<span
style='letter-spacing:-.95pt'> </span>85881<span style='letter-spacing:-.8pt'> </span>qui<span
style='letter-spacing:-1.0pt'> </span>comprend<span style='letter-spacing:-.85pt'>
</span>des<span style='letter-spacing:-.8pt'> </span>informations<span
style='letter-spacing:-.8pt'> </span>sur<span style='letter-spacing:-.9pt'> </span>le<span
style='letter-spacing:-.8pt'> </span><span class=GramE>jeu<span
style='letter-spacing:-.7pt'> </span>.</span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>En</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>s abonnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:1.45pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>acceptent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>comprennent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>conditions<span style='letter-spacing:-1.0pt'>
</span>g n rales<span style='letter-spacing:-.85pt'> </span>compl tes<span
style='letter-spacing:-1.05pt'> </span>et<span style='letter-spacing:-1.05pt'> </span>acceptent
de&nbsp;:<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:77.45pt;margin-bottom:
0in;margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-align:
justify;text-indent:-.25in;mso-list:l0 level1 lfo8;tab-stops:64.3pt'><![if !supportLists]><span
lang=FR><span style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Recevoir<span style='letter-spacing:-1.05pt'> </span>un<span
style='letter-spacing:-.95pt'> </span>message<span style='letter-spacing:-1.0pt'>
</span>de<span style='letter-spacing:-.85pt'> </span>bienvenue <span
style='letter-spacing:-.3pt'>comprenant</span><span style='letter-spacing:-1.2pt'>
</span><span style='letter-spacing:-.3pt'>un</span><span style='letter-spacing:
-1.2pt'> </span><span style='letter-spacing:-.3pt'>lien</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.3pt'>vers</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.3pt'>le</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.3pt'>portail</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.3pt'>Web</span><span
style='letter-spacing:-1.05pt'> </span></span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.3pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:#467885;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>en</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>provenance</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>85881 sur leurs t l phones mobiles.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:77.45pt;margin-bottom:
0in;margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-indent:
-.25in;mso-list:l0 level1 lfo8;tab-stops:64.3pt'><![if !supportLists]><span
lang=FR><span style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Recevoir</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>code</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>v rification</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>soumis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>portail</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>but</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>compl ter<span style='letter-spacing:-.45pt'> </span>la<span
style='letter-spacing:-.4pt'> </span>confirmation<span style='letter-spacing:
-.25pt'> </span>d'abonnement<o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:77.45pt;mso-add-space:auto;tab-stops:
64.3pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.3pt'>Pour</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jouer,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>doit</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>se</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>connecter</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>site</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>saisir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>son</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>num ro </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>mobile</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>code</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d authentification</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re u</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>SMS</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>puis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>cliquer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>bouton</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>JOUER
</span><span class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>MAINTENANT </span></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'>Le 3<sup> </sup>premier jours d abonnement <span
class=GramE>sont<span style='mso-spacerun:yes'>  </span>gratuits</span> ,  </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.35pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>quatri me </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>co t</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sera</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>0,700</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DT</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>TTC</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'>Tant</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>reste</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>actif,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.35pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>peut</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>profiter</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les
fonctionnalit s.</span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Lors</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'inscription,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re oit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>message</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>bienvenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>contenant
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d tails</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span class=GramE><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>jeu</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>,</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>comprend</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lien</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>web
football</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>fantasy</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>connecter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>automatiquement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'aide</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>identifiants.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Les
clients</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>peuvent</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>profiter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du
jeu en</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>utilisant</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>leur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>activ 
automatiquement</span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevra</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>budget</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>virtuel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>80</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>unit s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pour
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>constituer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> quipe</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>web</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:1.8pt'> </span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.2pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:89.8pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto;text-align:justify'><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>s'engage</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevoir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>offres
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>promotionnelles<span style='letter-spacing:
-.9pt'> </span>de<span style='letter-spacing:-.9pt'> </span>l'Organisateur<span
style='letter-spacing:-1.0pt'> </span>sur<span style='letter-spacing:-1.0pt'> </span>son<span
style='letter-spacing:-.95pt'> </span>t l phone<span style='letter-spacing:
-.9pt'> </span>portable.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Tout</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><b><u><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>nouvel</span></u></b><b><u><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span></u></b><b><u><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>abonn </span></u></b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>b n ficie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jours</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>gratuit.
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>L abonnement au <span
class=GramE>jeu <span style='letter-spacing:-1.15pt'><span
style='mso-spacerun:yes'> </span></span>est</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>factur </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>client</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>0.7</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DT/Jour
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>quatri me</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p></o:p></span></p>

<h4 style='margin-top:0in;margin-right:57.5pt;margin-bottom:2.0pt;margin-left:
64.3pt;mso-add-space:auto;tab-stops:91.45pt'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>L abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>renouvelable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>automatiquement.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Chaque</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>renouvellement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>r ussie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>factur </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>attribuera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.4pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l utilisateur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><b><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;color:black;
letter-spacing:-.3pt'>un</span></b><b><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black;letter-spacing:-.65pt'> </span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.3pt'>budget</span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.65pt'> </span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.3pt'>virtuel </span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black'> gale<span style='letter-spacing:-.8pt'> </span> <span
style='letter-spacing:-.95pt'> </span>0.5<span style='letter-spacing:-.8pt'> </span>Unit </span></b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:1.75pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black'> <span style='letter-spacing:-.95pt'> </span>son<span
style='letter-spacing:-.85pt'> </span>compte<span style='letter-spacing:-.9pt'>
</span>football<span style='letter-spacing:-.95pt'> </span>fantasy<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:53.8pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Tous</span><span lang=FR style='font-size:
11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>messages</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>promotionnels</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>li s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>envoy </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>aux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participants</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sont gratuits.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:53.8pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:35.7pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Le</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>doit</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.3pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>v rifier</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>num ro</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>t l phone</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>portable</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>utilis </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pour </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participer</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>correct</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>exact.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Ainsi,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>signant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>formulaire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d'abonnement, </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>confirme</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>num ro</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>t l phone</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>utilis </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sien,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>celui</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dont</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>personnellement<span style='letter-spacing:
-.75pt'> </span>responsable.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0in;margin-right:35.7pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>L'abonn </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>accepte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevoir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>alertes</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>offres</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>publicitaires,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toute</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>autre</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>campagne</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'Organisateur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>t l phone</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>mobile</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>lien avec le jeu.<o:p></o:p></span></p>

<p class=MsoListParagraph style='margin-top:0in;margin-right:33.6pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;tab-stops:46.1pt'><!--[if gte vml 1]><v:shapetype
 id="_x0000_t75" coordsize="21600,21600" o:spt="75" o:preferrelative="t"
 path="m@4@5l@4@11@9@11@9@5xe" filled="f" stroked="f">
 <v:stroke joinstyle="miter"/>
 <v:formulas>
  <v:f eqn="if lineDrawn pixelLineWidth 0"/>
  <v:f eqn="sum @0 1 0"/>
  <v:f eqn="sum 0 0 @1"/>
  <v:f eqn="prod @2 1 2"/>
  <v:f eqn="prod @3 21600 pixelWidth"/>
  <v:f eqn="prod @3 21600 pixelHeight"/>
  <v:f eqn="sum @0 0 1"/>
  <v:f eqn="prod @6 1 2"/>
  <v:f eqn="prod @7 21600 pixelWidth"/>
  <v:f eqn="sum @8 21600 0"/>
  <v:f eqn="prod @7 21600 pixelHeight"/>
  <v:f eqn="sum @10 21600 0"/>
 </v:formulas>
 <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
 <o:lock v:ext="edit" aspectratio="t"/>
</v:shapetype><v:shape id="Image_x0020_2" o:spid="_x0000_s1026" type="#_x0000_t75"
 style='position:absolute;left:0;text-align:left;margin-left:332.65pt;
 margin-top:6.5pt;width:9.2pt;height:9.05pt;z-index:251659264;visibility:visible;
 mso-wrap-style:square;mso-wrap-distance-left:0;mso-wrap-distance-top:0;
 mso-wrap-distance-right:0;mso-wrap-distance-bottom:0;
 mso-position-horizontal:absolute;mso-position-horizontal-relative:page;
 mso-position-vertical:absolute;mso-position-vertical-relative:text'>
 <v:imagedata src="terms_condition_files/image001.png" o:title=""/>
 <o:lock v:ext="edit" aspectratio="f"/>
 <w:wrap anchorx="page"/>
</v:shape><![endif]--><![if !vml]><span style='mso-ignore:vglayout;position:
absolute;z-index:251659264;left:0px;margin-left:562px;margin-top:430px;
width:15px;height:15px'><img width=12 height=12
src="terms_condition_files/image002.png" v:shapes="Image_x0020_2"></span><![endif]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le<span style='letter-spacing:-1.05pt'> </span>participant<span
style='letter-spacing:-1.05pt'> </span>accepte<span style='letter-spacing:-1.0pt'>
</span> <span style='letter-spacing:-1.2pt'> </span>l'avance,<span
style='letter-spacing:-1.15pt'> </span>de<span style='letter-spacing:-1.05pt'> </span>recevoir<span
style='letter-spacing:-1.25pt'> </span>des<span style='letter-spacing:-1.05pt'>
</span>SMS<span style='letter-spacing:-1.25pt'> </span>au<span
style='letter-spacing:-1.2pt'> </span>num ro<span style='letter-spacing:-1.25pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>t l phone<span
style='letter-spacing:-1.15pt'> </span>qu'il<span style='letter-spacing:-1.1pt'>
</span>a utilis <span style='letter-spacing:-1.05pt'> </span>pour<span
style='letter-spacing:-1.25pt'> </span>s'abonner<span style='letter-spacing:
-1.15pt'> </span>au<span style='letter-spacing:-1.2pt'> </span>jeu,<span
style='letter-spacing:-1.15pt'> </span>y<span style='letter-spacing:-1.15pt'> </span>compris,<span
style='letter-spacing:-1.15pt'> </span>mais<span style='letter-spacing:-1.15pt'>
</span>sans<span style='letter-spacing:-1.05pt'> </span>s'y<span
style='letter-spacing:-1.2pt'> </span>limiter<span style='letter-spacing:-1.25pt'>
</span>:<span style='letter-spacing:-1.15pt'> </span>Des<span style='letter-spacing:
-1.2pt'> </span>messages,<span style='letter-spacing:-1.15pt'> </span>qu'il<span
style='letter-spacing:-1.25pt'> </span>s'agisse d'alertes,<span
style='letter-spacing:-1.15pt'> </span>de<span style='letter-spacing:-1.05pt'> </span>notifications,<span
style='letter-spacing:-1.15pt'> </span>des<span style='letter-spacing:-1.15pt'>
</span>derni res<span style='letter-spacing:-1.15pt'> </span>mises<span
style='letter-spacing:-1.2pt'> </span> <span style='letter-spacing:-1.2pt'> </span>jour,<span
style='letter-spacing:-1.15pt'> </span>des<span style='letter-spacing:-1.2pt'> </span>informations<span
style='letter-spacing:-1.15pt'> </span>sur<span style='letter-spacing:-1.1pt'> </span>le<span
style='letter-spacing:-1.05pt'> </span>compte<span style='letter-spacing:-1.05pt'>
</span>ou des<span style='letter-spacing:-.15pt'> </span>informations<span
style='letter-spacing:-.1pt'> </span>sur le<span style='letter-spacing:-.1pt'> </span>jeu.<o:p></o:p></span></p>

<p class=MsoNormal style='tab-stops:46.2pt'><span lang=FR style='font-size:
12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'><span style='mso-tab-count:
1'>                   </span>Le</span><span lang=FR style='font-size:12.0pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>peut</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>se</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d sinscrire</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>moment</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:28.2pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l1 level3 lfo4;tab-stops:64.3pt 66.65pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span class=GramE><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>en</span></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>envoyant<span style='letter-spacing:
-.85pt'> </span><b style='mso-bidi-font-weight:normal'>GRATUITEMENT<span
style='letter-spacing:-.75pt'> </span></b>la<span style='letter-spacing:-.9pt'>
</span>commande<span style='letter-spacing:-.85pt'> </span> <span
style='letter-spacing:-.95pt'> </span><b style='mso-bidi-font-weight:normal'>STOP<span
style='letter-spacing:-.9pt'> </span>FF</b> <span style='letter-spacing:-.85pt'>
</span>au<span style='letter-spacing:-.85pt'> </span>num ro<span
style='letter-spacing:-.9pt'> </span><b>85881.<span style='letter-spacing:-.85pt'>
</span></b><span class=GramE>il</span><span style='letter-spacing:-.85pt'> </span>ne
recevra<span style='letter-spacing:-.05pt'> </span>plus de messages SMS li s au
Jeu ,<span style='letter-spacing:-.05pt'> </span>la d sinscription n entraine
pas la remise   z ro du solde des points et la r inscription ne donne plus
droit   la <span style='letter-spacing:-.1pt'>gratuit .</span><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:64.25pt;mso-add-space:
auto;text-indent:-17.95pt;mso-list:l1 level3 lfo4;tab-stops:64.25pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Via</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>menu</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>USSD</span></b><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span></b><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>*898*3<span
class=GramE>#<span style='letter-spacing:-.75pt'> </span>,<span
style='font-weight:normal'>choix</span></span></span></b><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d sinscription</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Football</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:64.25pt;mso-add-space:
auto;text-indent:-17.95pt;mso-list:l1 level3 lfo4;tab-stops:64.25pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Via</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>le</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>portail</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>cliquant</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>d sinscrire</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:64.25pt;mso-add-space:
auto;tab-stops:64.25pt'><span lang=FR style='font-size:12.0pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>ARTICLE<span style='letter-spacing:-1.15pt'> </span>5<span
style='letter-spacing:-1.05pt'> </span>:<span style='letter-spacing:-1.15pt'> </span>CONDITIONS<span
style='letter-spacing:-1.1pt'> </span>D' LIGIBILIT <span style='letter-spacing:
-1.0pt'> </span></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
20.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'>:</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:20.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Sont</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>exclus</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ce</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>personnel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>familles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>personnel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.35pt'>Tunisie</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>T l com</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span class=SpellE><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>Numbase</span></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:.3pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Tunisie</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'>Huissier</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>justice</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>notaire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>charg s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pr sent</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r glement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:34.6pt;mso-add-space:auto;
tab-stops:34.6pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h2 style='margin-top:0in;mso-add-space:auto;tab-stops:100.3pt'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>ARTICLE</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>6</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'> Date</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Syst me</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span class=GramE><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>r compense</span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:16.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>:</span></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:16.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></h2>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Chaque<span style='letter-spacing:-.95pt'> </span>semaine,<span
style='letter-spacing:-.95pt'> </span>les<span style='letter-spacing:-.95pt'> </span>participants<span
style='letter-spacing:-.9pt'> </span>au<span style='letter-spacing:-.95pt'> </span>jeu<span
style='letter-spacing:-.95pt'> </span>&quot;Football<span style='letter-spacing:
-.9pt'> </span>Fantasy&quot;<span style='letter-spacing:-.95pt'> </span>sont<span
style='letter-spacing:-.9pt'> </span>invit s<span style='letter-spacing:-1.0pt'>
</span> <span style='letter-spacing:-1.0pt'> </span>composer<span
style='letter-spacing:-1.05pt'> </span>leur <span style='letter-spacing:-.1pt'> quipe</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>et</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'> </span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>interagir</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>avec</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>jeu</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>pour</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>accumuler</span><span
style='letter-spacing:-1.35pt'> </span><span style='letter-spacing:-.1pt'>des</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>points.</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>Le</span><span
style='letter-spacing:1.15pt'> </span><span style='letter-spacing:-.1pt'>participant</span><span
style='letter-spacing:1.25pt'> </span><span style='letter-spacing:-.1pt'>ayant</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>obtenu</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>le </span><span
style='letter-spacing:-.2pt'>meilleur</span><span style='letter-spacing:-1.05pt'>
</span><span style='letter-spacing:-.2pt'>score</span><span style='letter-spacing:
-1.0pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>fin</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>semaine</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>remporte</span><span
style='letter-spacing:-.95pt'> </span><b><span style='letter-spacing:-.2pt'>le</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>prix</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>hebdomadaire</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>:1000
DTTC/championnat</span></b><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:29.4pt;
margin-bottom:0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:46.1pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Chaque</span><span lang=FR style='font-size:
11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>souscription</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r ussie</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>booste</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>budget</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span></b><a
name="_Hlk209597509"><b><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>virtuel</span></b></a><span style='mso-bookmark:
_Hlk209597509'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.7pt'> </span></span><span style='mso-bookmark:_Hlk209597509'></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l abonn </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>!</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Chaque</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re oit </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>0,5</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>unit </span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> <b>virtuelles </b></span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>suppl mentaire</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>lui</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.55pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>permettant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>d investir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>strat giquement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>dans</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l'achat</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:2.0pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>joueurs </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>virtuels.</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Plus</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>budget</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>grandit,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>plus</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>possibilit s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>victoire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
class=GramE><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'>augmentent</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>.</span></b></span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p></o:p></span></b></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:29.4pt;
margin-bottom:0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:46.1pt'><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoListParagraphCxSpLast style='margin-left:28.3pt;mso-add-space:auto;
text-indent:-17.9pt;mso-list:l8 level2 lfo2;tab-stops:136.2pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.1pt;mso-font-width:92%'><span
style='mso-list:Ignore'>6.1<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>M CANISME<span style='letter-spacing:-.75pt'> </span>DE<span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>NOTATION</span><o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:10.4pt;margin-bottom:.0001pt;mso-add-space:auto'><span class=GramE><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>L </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>attribution</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>points</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fait</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>comme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>suit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<div align=center>

<table class=TableNormal1 border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none;mso-border-alt:solid #9E9E9E .75pt;
 mso-yfti-tbllook:480;mso-padding-alt:0in 0in 0in 0in;mso-border-insideh:.75pt solid #9E9E9E;
 mso-border-insidev:.75pt solid #9E9E9E'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:3.25pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:3.25pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Footballeur</span></b><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></b></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border:solid #9E9E9E 1.0pt;
  border-left:none;mso-border-left-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:3.25pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Points</span></b><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></b></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:1;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>avoir</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.75pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>jou </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.85pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>jusqu' </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>60</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>minutes</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>1</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:2;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>avoir</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>jou </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>60</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>minutes</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>ou</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>plus</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>(hors</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>temps</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>d'arr t)</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>2</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:3;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.25pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>gardien</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>ou</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>d fenseur</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>6</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:4;height:15.55pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.55pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.2pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.75pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>milieu</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>de</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.65pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>terrain</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.55pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>5</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:5;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>attaquant</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>4</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:6;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'>Pour<span style='letter-spacing:-.5pt'> </span>claques<span
  style='letter-spacing:-.65pt'> </span>passe<span style='letter-spacing:-.55pt'>
  </span><span style='letter-spacing:-.1pt'>decisive</span><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>3</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:7;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>But</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>contre</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>son</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>camp</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'>-<span style='letter-spacing:-.5pt'>2</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:8;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>3</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>tirs</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>arr t s</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>par</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>un</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.2pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>gardien</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>de</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt;mso-ansi-language:
  EN-US'>but</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>1</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:9;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>clean</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>sheet</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>:</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span class=SpellE><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>gardien</span></span><span style='font-size:11.5pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>de</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>but</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>ou</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>d fenseur</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>4</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:10;height:15.85pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>clean</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.2pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>sheet</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>:</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'> <span style='letter-spacing:-.1pt'>un</span><span
  style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>milieu</span><span
  style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
  style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>terrain</span><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>1</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:11;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span style='font-size:
  11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>arr t</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>de</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>p nalty</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>5</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:12;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span style='font-size:
  11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>penalty</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>rat </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>2</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:13;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>chaque</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.95pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>carton</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>jaune</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>1</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:14;mso-yfti-lastrow:yes;height:15.85pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>chaque</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.95pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>carton</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>rouge</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>3</span><o:p></o:p></span></p>
  </td>
 </tr>
</table>

</div>

<p class=MsoNormal style='tab-stops:136.25pt'><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoListParagraph style='margin-left:28.3pt;mso-add-space:auto;
text-indent:-17.9pt;mso-list:l8 level2 lfo2;tab-stops:136.25pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.1pt;mso-font-width:92%'><span
style='mso-list:Ignore'>6.2<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Prix</span></b><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>m canisme</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gain</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:30.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Football</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>offre</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>prix</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>hebdomadaires</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pendant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>dur e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<h4 style='margin-top:0in;margin-right:0in;margin-bottom:2.0pt;margin-left:
1.5in;mso-add-space:auto;text-indent:-.25in;mso-list:l4 level3 lfo10'><![if !supportLists]><span
lang=FR style='font-family:Wingdings;mso-fareast-font-family:Wingdings;
mso-bidi-font-family:Wingdings;font-style:normal;mso-bidi-font-style:italic'><span
style='mso-list:Ignore'> <span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Prix</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>hebdomadaires</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.35pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:56.2pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>Chaque</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>semaine,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>attribue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>1</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>gagnant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>un</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>prix</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>1000</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>TND <span class=GramE>TTC<span
style='letter-spacing:-.45pt'> </span><span style='mso-spacerun:yes'> </span><u><span
style='letter-spacing:0pt;font-weight:normal'>par</span></u></span></span></b><u><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'> championnat</span></u><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> (y </span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>compris</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>taxes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>autres</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> ventuelles</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>taxes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>retenue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>source).<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:56.2pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le jeu s  tale sur 12 semaines   raison
de <span class=GramE>deux championnat</span> par semaine. Au total la valeur
des lots cash s  l ve   24 000 DT TTC<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:33.6pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>total</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>points</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>collect s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tous</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jou s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>actif</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>cours<span style='letter-spacing:-.45pt'>
</span>d'une<span style='letter-spacing:-.6pt'> </span>semaine<span
style='letter-spacing:-.6pt'> </span>sp cifique<span style='letter-spacing:
-.6pt'> </span>est<span style='letter-spacing:-.65pt'> </span>pris<span
style='letter-spacing:-.6pt'> </span>en<span style='letter-spacing:-.55pt'> </span>compte<span
style='letter-spacing:-.6pt'> </span>dans<span style='letter-spacing:-.6pt'> </span>le<span
style='letter-spacing:-.6pt'> </span>classement<span style='letter-spacing:
-.8pt'> </span>des </span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>joueurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>ligue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>qu il</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>a</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>choisie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l attribution</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Prix</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>hebdomadaire.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.25pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Deux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Championnats</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>font</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l objet</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>football</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>fantasy</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>prix </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>hebdomadaire  </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>savoir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ligue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>anglaise</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Premier</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>League</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ligue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>espagnole</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>La</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Liga</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Chaque semaine, les points collect s au
cours d'une semaine sp cifique sont r initialis s.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Chaque abonn  peut gagner le Prix
hebdomadaire plusieurs fois pendant la dur e du jeu qui est de 90 jours.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le Prix Hebdomadaire sera attribu  sur
la base du meilleur score entre tous les participants actifs dans le jeu TT
football fantasy. Tous les participants participeront au classement avec le
nombre de points r colt s dans la semaine.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>La semaine est consid r e du lundi <span
class=GramE>00:</span>00:00 heures au dimanche suivant   23:59:59 heures.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>R f rences du jeu Football fantasy : Les
calendriers des championnats de football de premier League Anglais et la Liga
Espagnol.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Une c r monie de remise des lots sera
organis e   une date d finie en commun accord entre Tunisie T l com et <span
class=SpellE>Numbase</span> Tunisie. Aucun lot ne peut  tre distribu  avant la
date de c r monie.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le gagnant du prix instantan  sera
contact  dans les 48 heures.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>L application de la retenue   la source
de 25% aux montants pay s en Dinars Tunisiens et ceci selon l article 19 de la
loi de finance 2016 mis en vigueur   partir du premier janvier 2016.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>L'organisateur se r serve le droit de
disqualifier tout participant qui semble avoir enfreint l'une des dispositions
des Conditions G n rales.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Les clients qui participent   Tunisie <span
class=SpellE>telecom</span> football fantasy garantissent par la pr sente que
toutes les informations soumises sont v ridiques,   jour et compl tes les
gagnants  ligibles pour gagner les lots hebdomadaires sont d finis dans
l article 5.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>La liste de classement des
participation<span style='mso-spacerun:yes'>   </span>sera <span class=GramE>effectu <span
style='mso-spacerun:yes'>  </span>par</span> le<span style='mso-spacerun:yes'> 
</span>notaire et un PV de d claration des gagnants sera diffus <span
style='mso-spacerun:yes'>  </span>chaque semaine selon le tableau provisionnel
suivant <o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:46.3pt;mso-add-space:auto'><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></p>

<div align=center>

<table class=TableNormal1 border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none;mso-border-alt:solid black 1.0pt;
 mso-yfti-tbllook:480;mso-padding-alt:0in 0in 0in 0in;mso-border-insideh:1.0pt solid black;
 mso-border-insidev:1.0pt solid black'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:14.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Date</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border:solid black 1.0pt;
  border-left:none;mso-border-left-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:29.55pt;
  margin-bottom:0in;margin-left:30.7pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center;text-indent:-.1pt'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Lot </span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Championnat
  Anglais</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border:solid black 1.0pt;
  border-left:none;mso-border-left-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:51.0pt;
  margin-bottom:0in;margin-left:52.35pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center;text-indent:-.1pt'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Lot </span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Championnat
  Espagnol</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:1;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>1:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>06/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:2;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>2</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>13/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:3;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>3</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>20/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:4;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>4</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>27/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:5;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>5:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>03/11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:6;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>6</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>10//11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:7;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>7</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>17/11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:8;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>8:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>24/11/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:9;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>9</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>01/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:10;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>10</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>08/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:11;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>11:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>15/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:12;mso-yfti-lastrow:yes;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>12</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>22/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
</table>

</div>

<h4 style='margin-top:0in;margin-right:32.55pt;margin-bottom:2.0pt;margin-left:
0in;mso-add-space:auto'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black;background:yellow;mso-highlight:
yellow'><o:p>&nbsp;</o:p></span></h4>

<h4 style='margin-top:0in;margin-right:32.55pt;margin-bottom:2.0pt;margin-left:
0in;mso-add-space:auto'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black'>NB<span style='letter-spacing:
-1.15pt'> </span>:<span style='letter-spacing:-1.05pt'> </span>Les<span
style='letter-spacing:-1.15pt'> </span>r gles<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-1.2pt'> </span>participation<span
style='letter-spacing:-1.15pt'> </span> <span style='letter-spacing:-1.2pt'> </span>la<span
style='letter-spacing:-1.1pt'> </span>proc dure<span style='letter-spacing:
-1.15pt'> </span>de<span style='letter-spacing:-1.2pt'> </span>s lection<span
style='letter-spacing:-1.05pt'> </span>des<span style='letter-spacing:-1.05pt'>
</span>Gagnants<span style='letter-spacing:-1.15pt'> </span>sont<span
style='letter-spacing:-1.1pt'> </span>les <span style='letter-spacing:-.1pt'>suivantes</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Lors</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>chaque</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>proc dure</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>s lection</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnants,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>principal</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.8pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>rempla ants</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>sont<span
style='letter-spacing:-1.2pt'> </span>d sign s<span style='letter-spacing:-1.15pt'>
</span>par<span style='letter-spacing:-1.1pt'> </span>l huissier<span
style='letter-spacing:-1.1pt'> </span>de<span style='letter-spacing:-1.15pt'> </span>justice.<span
style='letter-spacing:-1.15pt'> </span>La<span style='letter-spacing:-1.2pt'> </span>s lection<span
style='letter-spacing:-1.2pt'> </span>se<span style='letter-spacing:-1.15pt'> </span>fait<span
style='letter-spacing:-1.2pt'> </span>parmi<span style='letter-spacing:-1.1pt'>
</span>les<span style='letter-spacing:-1.15pt'> </span>quatre participants<span
style='letter-spacing:-.9pt'> </span>ayant<span style='letter-spacing:-.8pt'> </span>obtenu<span
style='letter-spacing:-.75pt'> </span>les<span style='letter-spacing:-.95pt'> </span>meilleurs<span
style='letter-spacing:-.9pt'> </span>scores<span style='letter-spacing:-.75pt'>
</span>dans<span style='letter-spacing:-.75pt'> </span>chaque<span
style='letter-spacing:-.9pt'> </span>championnat.<span style='letter-spacing:
-.9pt'> </span>Si<span style='letter-spacing:-.8pt'> </span>le<span
style='letter-spacing:-.9pt'> </span>gagnant <span style='letter-spacing:-.2pt'>principal</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>ne</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.2pt'>r pond</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>pas</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>l appel</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>sur</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>sa</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>ligne</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>t l phonique</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>avant</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>13h</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>le</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>jour</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>s lection,
</span><span style='letter-spacing:-.1pt'>est</span><span style='letter-spacing:
-.95pt'> </span><span style='letter-spacing:-.1pt'>injoignable,</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>refuse</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>prix</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>ou</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>ne</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>se</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>pr sente</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>pas</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>pour</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>r cup rer</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.1pt'>dans</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>les</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.1pt'>10</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>jours
suivant</span><span style='letter-spacing:-.8pt'> </span><span
style='letter-spacing:-.1pt'>la</span><span style='letter-spacing:-.7pt'> </span><span
style='letter-spacing:-.1pt'>notification</span><span style='letter-spacing:
-.8pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>la</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>seconde</span><span
style='letter-spacing:-.6pt'> </span><span style='letter-spacing:-.1pt'>lettre</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>recommand e,</span><span
style='letter-spacing:-.75pt'> </span><span class=SpellE><span
style='letter-spacing:-.1pt'>Numbase</span></span><span style='letter-spacing:
-.75pt'> </span><span style='letter-spacing:-.1pt'>Tunisie</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>contactera</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>le
premier</span><span style='letter-spacing:-1.2pt'> </span><span
style='letter-spacing:-.1pt'>rempla ant</span><span style='letter-spacing:-1.2pt'>
</span><span style='letter-spacing:-.1pt'>selon</span><span style='letter-spacing:
-1.1pt'> </span><span style='letter-spacing:-.1pt'>l ordre</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>s lection.</span><span
style='letter-spacing:-1.25pt'> </span><span style='letter-spacing:-.1pt'>Celui-ci</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>sera</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>alors</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>inform </span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>qu il</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>a</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>remport 
</span>le<span style='letter-spacing:-1.05pt'> </span>prix.<span
style='letter-spacing:-1.15pt'> </span>Si<span style='letter-spacing:-1.2pt'> </span>n cessaire,<span
style='letter-spacing:-1.15pt'> </span>la<span style='letter-spacing:-1.35pt'> </span>proc dure<span
style='letter-spacing:-1.15pt'> </span>se<span style='letter-spacing:-1.15pt'> </span>poursuivra<span
style='letter-spacing:-1.25pt'> </span>avec<span style='letter-spacing:-1.15pt'>
</span>les<span style='letter-spacing:-1.2pt'> </span>autres<span
style='letter-spacing:-1.2pt'> </span>rempla ants<span style='letter-spacing:
-1.15pt'> </span>dans<span style='letter-spacing:-1.15pt'> </span>l ordre <span
style='letter-spacing:-.1pt'> tabli.<o:p></o:p></span></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.8pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Les</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>seront</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>contact s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>num ro</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>mobile</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>a</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> t </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>utilis </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>par<span style='letter-spacing:-.75pt'> </span>SMS.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les<span style='letter-spacing:-.95pt'> </span>participants<span
style='letter-spacing:-.9pt'> </span>sont<span style='letter-spacing:-.95pt'> </span>inform s<span
style='letter-spacing:-.95pt'> </span>que<span style='letter-spacing:-.9pt'> </span>toutes<span
style='letter-spacing:-.95pt'> </span>les<span style='letter-spacing:-.75pt'> </span>donn es<span
style='letter-spacing:-.75pt'> </span>fournies<span style='letter-spacing:-.95pt'>
</span>par<span style='letter-spacing:-.95pt'> </span>leur<span
style='letter-spacing:-.85pt'> </span>soin<span style='letter-spacing:-.85pt'> </span>sont
<span style='letter-spacing:-.2pt'>n cessaires</span><span style='letter-spacing:
-.95pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>prise</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>en</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>compte</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>leur</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.2pt'>participation</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>au</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>jeu</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>et</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>dotation</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>du</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>prix.</span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les<span style='letter-spacing:-1.2pt'> </span>participants<span
style='letter-spacing:-1.15pt'> </span>sont,<span style='letter-spacing:-1.15pt'>
</span>par<span style='letter-spacing:-1.1pt'> </span>cons quent,<span
style='letter-spacing:-1.15pt'> </span>tenus<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>s assurer<span
style='letter-spacing:-1.25pt'> </span>de<span style='letter-spacing:-1.15pt'> </span>la<span
style='letter-spacing:-1.1pt'> </span>validit <span style='letter-spacing:-1.15pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>ces<span
style='letter-spacing:-1.05pt'> </span>mentions. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Dans</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>cas</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>o </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>gagnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mineur,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>celui-ci</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>doit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>faire</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>repr senter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>parents
ou</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>par</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>son</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tuteur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l gal</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>apr s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pr sentation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>acte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>naissance</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mineur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>question</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>de<span style='letter-spacing:-.6pt'> </span>la<span
style='letter-spacing:-1.0pt'> </span>CIN<span style='letter-spacing:-.8pt'> </span>du<span
style='letter-spacing:-.75pt'> </span>parent<span style='letter-spacing:-.7pt'>
</span>ou<span style='letter-spacing:-.75pt'> </span>du<span style='letter-spacing:
-.6pt'> </span>tuteur<span style='letter-spacing:-.85pt'> </span>l gal.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>participation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>implique</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>automatiquement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l acceptation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>par
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>toutes</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>clauses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pr sent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>r glement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tous</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>avenants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ainsi</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> l ment</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disponible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>web</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:3.55pt'> </span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Une</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>c r monie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>remise</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lots</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>organis e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>date</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d finie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>commun</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>accord
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>entre<span style='letter-spacing:-.75pt'> </span><span
class=SpellE>TunisieT l com</span><span style='letter-spacing:-.8pt'> </span>et<span
style='letter-spacing:-.8pt'> </span><span class=SpellE>Numbase</span><span
style='letter-spacing:-.75pt'> </span>Tunisie.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:10.4pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>L application</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>retenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>source</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lib ratoire</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>25%</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>selon</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l article</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>19</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>loi</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de
finances</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>2016</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lots</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Dinars</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Tunisiens</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>(1000</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>DT)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>remis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>directement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>aux
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>gagnants<span style='letter-spacing:-.35pt'> </span>relatifs<span
style='letter-spacing:-.35pt'> </span>au<span style='letter-spacing:-.45pt'> </span>pr sent<span
style='letter-spacing:-.3pt'> </span>JEU<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>TT</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>cet</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.3pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>article</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>mis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>vigueur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>1er</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>janvier</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>2016.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>ARTICLE<span
style='letter-spacing:-1.05pt'> </span>7<span style='letter-spacing:-1.15pt'> </span>:<span
style='letter-spacing:-1.0pt'> </span>SERVICE<span style='letter-spacing:-1.1pt'>
</span><span style='letter-spacing:-.1pt'>CLIENT<o:p></o:p></span></span></h3>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></h3>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Soci t </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Promoteur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>met</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disposition</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Service</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Client</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>joignable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>t l phone</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>(1298)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>71</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>00</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>1298</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toute</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>demande</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d information.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>ARTICLE<span
style='letter-spacing:-1.05pt'> </span>8<span style='letter-spacing:-1.2pt'> </span>:<span
style='letter-spacing:-1.05pt'> </span>IDENTIFICATION<span style='letter-spacing:
-1.1pt'> </span>DES<span style='letter-spacing:-1.2pt'> </span>PARTICIPANTS<span
style='letter-spacing:-1.1pt'> </span>ET<span style='letter-spacing:-1.1pt'> </span>DES<span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>GAGNANTS<o:p></o:p></span></span></h3>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></h3>

<p class=MsoBodyText style='margin-top:0in;margin-right:38.0pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Chaque</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>identifi </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>num ro</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>portable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>(MSISDN)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>lui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>attribu 
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>lors<span style='letter-spacing:-.95pt'> </span>de<span
style='letter-spacing:-.9pt'> </span>l'achat<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-.9pt'> </span>la<span style='letter-spacing:
-1.05pt'> </span>ligne<span style='letter-spacing:-1.0pt'> </span>GSM.<span
style='letter-spacing:-1.0pt'> </span>Le<span style='letter-spacing:-1.0pt'> </span>contrat<span
style='letter-spacing:-1.05pt'> </span>de<span style='letter-spacing:-1.0pt'> </span>vente<span
style='letter-spacing:-.9pt'> </span> <span style='letter-spacing:-1.05pt'> </span>son<span
style='letter-spacing:-1.05pt'> </span>nom<span style='letter-spacing:-1.05pt'>
</span>et<span style='letter-spacing:-1.05pt'> </span>son<span
style='letter-spacing:-1.05pt'> </span>CIN<span style='letter-spacing:-1.05pt'>
</span>faisant<span style='letter-spacing:-1.05pt'> </span>foi.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les gagnants au jeu SMS sont les abonn s qui seront d sign s par
la proc dure de d signation des gagnants ils devront  tre les propri taires de
la ligne GSM avec laquelle ils ont jou  au JEU TT Football Fantasy.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Si une personne participe au Jeu avec une ligne (un MSISDN) qui
n est pas sa propri t  et que cet MSISDN est s lectionn  comme Gagnant par la
proc dure de d signation des gagnants, cette personne doit, pour b n ficier du
Lot en question, pr senter une procuration  crite du propri taire de la Ligne
(du MSISDN) pour retirer le lot dans un d lai ne d passant pas un mois  
compter de la date de sa s lection.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>ARTICLE 9 : ANNULATION DU JEU<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les soci t s organisatrice et promoteur pourront annuler tout ou
partie du pr sent jeu-<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>concours</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> dans les cas de force majeure ou s il appara t que des fraudes
sont intervenues sous quelque forme que ce soit et notamment de mani re
informatique dans le cadre de la participation au pr sent jeu-concours ou de la
d termination des gagnants.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Elles se r servent, dans cette hypoth se, le droit de ne pas
attribuer les gains aux fraudeurs et/ou de poursuivre devant les juridictions
comp tentes les auteurs de ces fraudes.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>En particulier, sont consid r es comme frauduleuses les m thodes
de participation automatiques au moyen d un logiciel, d un mat riel, d un
automate ou de tout autre dispositif qui ne constitue pas une participation
manuelle.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>On entend par participation manuelle, l envoi d un message par SMS
qui r sulte de l action manuelle d un participant utilisant le clavier d un
t l phone mobile.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>10:</span> D p t du R glement<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le pr sent r glement est d pos  chez Le Notaire, Ma tre <span
class=SpellE>Sadok</span> AL <span class=SpellE>Amdouni</span> dont le cabinet
est Avenue Hedi Chaker, centre <span class=SpellE>Firas</span>, Cit  <span
class=SpellE>Erriadh</span>, La <span class=SpellE>marsa</span> Tunis domicili 
pour ce jeu   caract re fantasy football. Ce r glement sera communiqu 
gratuitement   toute personne faisant la demande aupr s du notaire Ma tre <span
class=SpellE>Sadok</span> AL <span class=SpellE>Amdouni</span>. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les d signations des gagnants sont <span class=GramE>r alis s</span>
sous le contr le de l Huissier de justice, Ma tre Nabil <span class=SpellE>Fakhfakh</span>
dont le cabinet est 9 rue d Autriche 2eme  tage app 12, 1002, belv d re Tunis.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>11:</span> Mode de d claration des
r sultats<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=SpellE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>Numbase</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> Tunisie contactera chaque gagnant par t l phone. Celui-ci sera
invit  au si ge de ladite soci t , ou   lieu d sign  par <span class=SpellE>Numbase</span>
Tunisie pour la c r monie de remise des lots, afin d'obtenir son cadeau. Le
gagnant doit ramener sa carte d'identit  afin de v rifier qu'il est bien le
propri taire de la ligne GSM, et une preuve (Contrat, facture t l phonique,
etc.) prouvant que la ligne (le MSISDN) est le sien, sinon dans le cas  ch ant
une procuration ou un acte de cession du lot en question par le propri taire de
la ligne (de l MSISDN)   l utilisateur de la ligne (de l MSISDN).<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le d lai maximum pour r clamer les lots sera 60 jours   partir de
la date de remise des lots.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Tout gagnant ayant des factures de Tunisie Telecom non pay es ne
peut b n ficier de son gain que suite au r glement de la totalit  de ses dus et
ce dans un d lai ne<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>d passant</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> pas les 7 jours ouvrables   l annonce. Faute de quoi un autre
gagnant sera<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>d sign </span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> selon la proc dure de s lection mentionn  ci-dessus.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>L attribution de tous les lots se fera maximum 45 jours apr s la
fin du jeu<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>12:</span> Exploitation des donn es
personnelles des gagnants<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Chaque participant, s'il devient gagnant, autorise les
organisateurs, ainsi que l'ensemble des soci t s de son groupe,   citer son nom
et ses coordonn es, et   utiliser ses photos, Vid os, d clarations lors de la
remise des lots par tous proc d s et sur tous supports, pendant une dur e de
cinq (5) ans, aux fins de promotion de leurs services respectifs, sans que ceci
lui ouvre d'autre droit, r mun ration ou indemnit  que la remise du prix
attribu .<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>ARTICLE <span class=GramE>13:</span> PROTECTION DES DONN ES
PERSONNELLES<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les informations nominatives recueillies dans le cadre du pr sent
jeu li es   l envoi et   la remise des lots gagn s sont trait es conform ment  
la Loi organique n 2004-63 du 27/07/2004 portant sur la protection des donn es
  caract re personnel.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article 14 : Remboursement<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Dans le cas o  le client demande un remboursement, <span
class=SpellE>Numbase</span> validera la demande et informera TUNISIE T l com en
cons quence. Le co t du SMS pour la participation au jeu peut  tre rembours 
dans la limite <span class=GramE>de un</span> (1) SMS par participant au prix
TTC du SMS. Les demandes de remboursement devront  tre adress es au plus tard
07 jours apr s la date de participation au jeu (le cachet de la poste faisant
foi)<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'> </span></span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'> l'adresse
suivante: Soci t  <span class=SpellE>Numbase</span> TUNISIE.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le timbre sera rembours  au tarif lent en vigueur dans les m mes
conditions  nonc es ci-dessus. Toute demande de remboursement ne contenant pas
les informations ci- dessous ne pourra  tre trait e :<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le nom du jeu ;<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le num ro SMS concern  (85881) ; L heure et la date des envois des
SMS ;<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Une copie du contrat d abonnement de l op rateur par lequel le SMS
a  t  envoy , Une preuve de paiement, une copie de la facture d taill e et pay 
de l'op rateur de t l communication par lequel le SMS a  t  envoy  ou toute
autre preuve de paiement. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Ne seront pas prises en consid ration les demandes de
remboursement dont les coordonn es seront incompl tes, celles adress es apr s
les d lais pr vus ci-dessus, celles ne respectant pas la forme des messages
prescrite   l'article 5 du pr sent r glement ou celles contraires aux
dispositions du pr sent r glement.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><span style='mso-spacerun:yes'> </span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>15:</span> Responsabilit <o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les SMS MO et MT qui n'arrivent pas aux participants pendant la
dur e du JEU TT football Fantasy pour quelque raison que ce soit n'entra nent
pas la responsabilit  des organisateurs qui, de bonne foi, s en remettent   la
diligence du r seau.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>TT et l'Organisateur d clinent toute responsabilit  pour, y
compris sans limitation, toute erreur, omission, interruption, d faut, retard
de fonctionnement ou de transmission, d faillance de la ligne de communication
lorsqu'elle n'est pas sous son contr le et son ex cution directs.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>TT et l'Organisateur se r servent le droit, chaque fois que cela
est jug  n cessaire, de suspendre temporairement le jeu <span class=SpellE>TTFootball</span>
Fantasy pour des raisons op rationnelles (par exemple pour des r parations, une
maintenance planifi e ou des mises   niveau). TT et l'Organisateur s'engagent  
r tablir le jeu <span class=SpellE>TTFootball</span> Fantasy dans les meilleurs
d lais apr s toute p riode de suspension temporaire.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>16:</span> Acceptation<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>La participation   ce jeu-concours entra ne l enti re acceptation
des dispositions du pr sent r glement dans leur int gralit , et ce, y compris
d' ventuelles modifications ult rieures ou annulation pouvant  tre rendues
n cessaires, par exemple, en cas de force majeure.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>17:</span> Litige<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les parties s'efforceront de r soudre   l amiable tout litige qui
surviendrait   l occasion de l ex cution du pr sent r glement. En cas de
d saccord d finitif, et sous r serves des dispositions l gales, les tribunaux
de Tunis 1 seront seuls comp tents.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

</div>

</body>

     </html>`
    }

  } 
},
ar:{
  "translation": {
    "incorrect": "غير صحيح",
    "already_subscriber": "مشترك بالفعل",
    "phoneplaceholder": "رقم الهاتف...",
    "play": "العب",
    "landing": {
      "verify": "تحقق",
      "continue": "متابعة",
      "title":"أنت ال Coach  أصنع أقوى تشكيلة Football Fantasy  وإربح كل جمعة </br> جوائز توصل إلى 2000 دينار</br> أداء فريقك في Premier league وإلا La Liga يربحك المليون!</br>",
      "pricepoint":"أول 3 أيام مجاناً ثم 0.7 د/يوم (تجديد تلقائي)",
    },
    "header": {
      "about": "حول",
      "createteam": "إنشاء فريق",
      "faq": "الأسئلة الشائعة"
    },
    "about": {
    "title": "عِش تجربة كرة القدم كما لم تفعل من قبل مع فانتازي فوتبول!",
      "teamwork": "العب في <br/> دوري كرة القدم المفضل لديك",
      "friend": "تنافس مع أصدقائك",
      "badge": "اربح جوائز رائعة"
    },
    "createteam": {
      "title": "أنشئ فريقك بأربع خطوات بسيطة",
      "wayONE": "اختر الدوري أو البطولة التي ترغب في اللعب بها",
      "wayTWO": "اختر اللاعبين بالضغط على زر + في كل مركز",
      "wayTHREE": "اختر قائد فريقك (تُضاعف نقاطه) ونائب القائد",
      "wayFOUR": "احصل على النقاط وشارك في المباريات الحقيقية بناءً على أداء اللاعبين"
    },
    "faq": {
      "title": "أسئلة؟ لدينا الإجابات",
      "question1": "كيف أبدأ مع فانتازي فوتبول؟",
      "answer1": "مع فانتازي فوتبول إليفن، يمكنك اختيار فريقك المثالي المكون من 11 لاعبًا من أفضل البطولات والمسابقات العالمية على مدار العام. احصل على النقاط وتنافس بناءً على أداء اللاعبين الحقيقي في المباريات الفعلية.",
      "question2": "ماذا يمكنني أن أربح من لعب فانتازي فوتبول؟",
      "answer2": "جوائز أسبوعية، إن وجدت",
      "question3": "هل يمكنني اللعب مع أصدقائي؟",
      "answer3": "بالطبع، يمكن للأصدقاء التسجيل والتنافس في كل تصنيف دوري.",
      "question4": "ما البطولات المتاحة على فانتازي فوتبول؟",
      "answer4": "نغطي أفضل البطولات العالمية مثل: كأس العالم، الدوري الإنجليزي الممتاز، الدوري الإسباني، الدوري السعودي للمحترفين، كأس أوروبا، كأس الأمم الأفريقية، وغير ذلك الكثير."
    },
    "footer": {
      "termsandcondition":"الشروط والأحكام",
       "termscondition":`<html xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office"
xmlns:w="urn:schemas-microsoft-com:office:word"
xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"
xmlns="http://www.w3.org/TR/REC-html40">

<head>
<meta http-equiv=Content-Type content="text/html; charset=windows-1252">
<meta name=ProgId content=Word.Document>
<meta name=Generator content="Microsoft Word 15">
<meta name=Originator content="Microsoft Word 15">
<link rel=File-List href="terms_condition_files/filelist.xml">
<link rel=Edit-Time-Data href="terms_condition_files/editdata.mso">
<!--[if !mso]>
<style>
v\:* {behavior:url(#default#VML);}
o\:* {behavior:url(#default#VML);}
w\:* {behavior:url(#default#VML);}
.shape {behavior:url(#default#VML);}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:DocumentProperties>
  <o:Author>Slim Beji</o:Author>
  <o:Template>Normal</o:Template>
  <o:LastAuthor>Tala Alkhatib</o:LastAuthor>
  <o:Revision>2</o:Revision>
  <o:TotalTime>2</o:TotalTime>
  <o:Created>2025-09-24T12:00:00Z</o:Created>
  <o:LastSaved>2025-09-24T12:00:00Z</o:LastSaved>
  <o:Pages>7</o:Pages>
  <o:Words>2727</o:Words>
  <o:Characters>15549</o:Characters>
  <o:Lines>129</o:Lines>
  <o:Paragraphs>36</o:Paragraphs>
  <o:CharactersWithSpaces>18240</o:CharactersWithSpaces>
  <o:Version>16.00</o:Version>
 </o:DocumentProperties>
 <o:OfficeDocumentSettings>
  <o:AllowPNG/>
 </o:OfficeDocumentSettings>
</xml><![endif]-->
<link rel=themeData href="terms_condition_files/themedata.thmx">
<link rel=colorSchemeMapping href="terms_condition_files/colorschememapping.xml">
<!--[if gte mso 9]><xml>
 <w:WordDocument>
  <w:SpellingState>Clean</w:SpellingState>
  <w:GrammarState>Clean</w:GrammarState>
  <w:TrackMoves>false</w:TrackMoves>
  <w:TrackFormatting/>
  <w:HyphenationZone>21</w:HyphenationZone>
  <w:PunctuationKerning/>
  <w:DrawingGridHorizontalSpacing>6 pt</w:DrawingGridHorizontalSpacing>
  <w:DrawingGridVerticalSpacing>8.15 pt</w:DrawingGridVerticalSpacing>
  <w:DisplayHorizontalDrawingGridEvery>2</w:DisplayHorizontalDrawingGridEvery>
  <w:DisplayVerticalDrawingGridEvery>2</w:DisplayVerticalDrawingGridEvery>
  <w:ValidateAgainstSchemas/>
  <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>
  <w:IgnoreMixedContent>false</w:IgnoreMixedContent>
  <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>
  <w:DoNotPromoteQF/>
  <w:LidThemeOther>FR</w:LidThemeOther>
  <w:LidThemeAsian>X-NONE</w:LidThemeAsian>
  <w:LidThemeComplexScript>AR-SA</w:LidThemeComplexScript>
  <w:Compatibility>
   <w:BreakWrappedTables/>
   <w:SnapToGridInCell/>
   <w:WrapTextWithPunct/>
   <w:UseAsianBreakRules/>
   <w:DontGrowAutofit/>
   <w:SplitPgBreakAndParaMark/>
   <w:EnableOpenTypeKerning/>
   <w:DontFlipMirrorIndents/>
   <w:OverrideTableStyleHps/>
  </w:Compatibility>
  <m:mathPr>
   <m:mathFont m:val="Cambria Math"/>
   <m:brkBin m:val="before"/>
   <m:brkBinSub m:val="&#45;-"/>
   <m:smallFrac m:val="off"/>
   <m:dispDef/>
   <m:lMargin m:val="0"/>
   <m:rMargin m:val="0"/>
   <m:defJc m:val="centerGroup"/>
   <m:wrapIndent m:val="1440"/>
   <m:intLim m:val="subSup"/>
   <m:naryLim m:val="undOvr"/>
  </m:mathPr></w:WordDocument>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <w:LatentStyles DefLockedState="false" DefUnhideWhenUsed="false"
  DefSemiHidden="false" DefQFormat="false" DefPriority="99"
  LatentStyleCount="376">
  <w:LsdException Locked="false" Priority="0" QFormat="true" Name="Normal"/>
  <w:LsdException Locked="false" Priority="9" QFormat="true" Name="heading 1"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 2"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 3"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 4"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 5"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 6"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 7"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 8"/>
  <w:LsdException Locked="false" Priority="9" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="heading 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index 9"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 1"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 2"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 3"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 4"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 5"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 6"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 7"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 8"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" Name="toc 9"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="header"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footer"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="index heading"/>
  <w:LsdException Locked="false" Priority="35" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="caption"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of figures"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="envelope return"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="footnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="line number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="page number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote reference"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="endnote text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="table of authorities"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="macro"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="toa heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Bullet 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Number 5"/>
  <w:LsdException Locked="false" Priority="10" QFormat="true" Name="Title"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Closing"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Signature"/>
  <w:LsdException Locked="false" Priority="1" SemiHidden="true"
   UnhideWhenUsed="true" Name="Default Paragraph Font"/>
  <w:LsdException Locked="false" Priority="1" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="Body Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="List Continue 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Message Header"/>
  <w:LsdException Locked="false" Priority="11" QFormat="true" Name="Subtitle"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Salutation"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Date"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text First Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Note Heading"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Body Text Indent 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Block Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="FollowedHyperlink"/>
  <w:LsdException Locked="false" Priority="22" QFormat="true" Name="Strong"/>
  <w:LsdException Locked="false" Priority="20" QFormat="true" Name="Emphasis"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Document Map"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Plain Text"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="E-mail Signature"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Top of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Bottom of Form"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal (Web)"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Acronym"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Address"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Cite"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Code"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Definition"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Keyboard"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Preformatted"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Sample"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Typewriter"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="HTML Variable"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Normal Table"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="annotation subject"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="No List"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Outline List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Simple 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Classic 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Colorful 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Columns 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Grid 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 4"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 5"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 7"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table List 8"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table 3D effects 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Contemporary"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Elegant"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Professional"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Subtle 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 1"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 2"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Web 3"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Balloon Text"/>
  <w:LsdException Locked="false" Priority="39" Name="Table Grid"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Table Theme"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Placeholder Text"/>
  <w:LsdException Locked="false" Priority="1" QFormat="true" Name="No Spacing"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 1"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 1"/>
  <w:LsdException Locked="false" SemiHidden="true" Name="Revision"/>
  <w:LsdException Locked="false" Priority="1" QFormat="true"
   Name="List Paragraph"/>
  <w:LsdException Locked="false" Priority="29" QFormat="true" Name="Quote"/>
  <w:LsdException Locked="false" Priority="30" QFormat="true"
   Name="Intense Quote"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 1"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 1"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 1"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 1"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 1"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 2"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 2"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 2"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 2"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 2"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 2"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 3"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 3"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 3"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 3"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 3"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 3"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 4"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 4"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 4"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 4"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 4"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 4"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 5"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 5"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 5"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 5"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 5"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 5"/>
  <w:LsdException Locked="false" Priority="60" Name="Light Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="61" Name="Light List Accent 6"/>
  <w:LsdException Locked="false" Priority="62" Name="Light Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="63" Name="Medium Shading 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="64" Name="Medium Shading 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="65" Name="Medium List 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="66" Name="Medium List 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="67" Name="Medium Grid 1 Accent 6"/>
  <w:LsdException Locked="false" Priority="68" Name="Medium Grid 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="69" Name="Medium Grid 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="70" Name="Dark List Accent 6"/>
  <w:LsdException Locked="false" Priority="71" Name="Colorful Shading Accent 6"/>
  <w:LsdException Locked="false" Priority="72" Name="Colorful List Accent 6"/>
  <w:LsdException Locked="false" Priority="73" Name="Colorful Grid Accent 6"/>
  <w:LsdException Locked="false" Priority="19" QFormat="true"
   Name="Subtle Emphasis"/>
  <w:LsdException Locked="false" Priority="21" QFormat="true"
   Name="Intense Emphasis"/>
  <w:LsdException Locked="false" Priority="31" QFormat="true"
   Name="Subtle Reference"/>
  <w:LsdException Locked="false" Priority="32" QFormat="true"
   Name="Intense Reference"/>
  <w:LsdException Locked="false" Priority="33" QFormat="true" Name="Book Title"/>
  <w:LsdException Locked="false" Priority="37" SemiHidden="true"
   UnhideWhenUsed="true" Name="Bibliography"/>
  <w:LsdException Locked="false" Priority="39" SemiHidden="true"
   UnhideWhenUsed="true" QFormat="true" Name="TOC Heading"/>
  <w:LsdException Locked="false" Priority="41" Name="Plain Table 1"/>
  <w:LsdException Locked="false" Priority="42" Name="Plain Table 2"/>
  <w:LsdException Locked="false" Priority="43" Name="Plain Table 3"/>
  <w:LsdException Locked="false" Priority="44" Name="Plain Table 4"/>
  <w:LsdException Locked="false" Priority="45" Name="Plain Table 5"/>
  <w:LsdException Locked="false" Priority="40" Name="Grid Table Light"/>
  <w:LsdException Locked="false" Priority="46" Name="Grid Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="Grid Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="Grid Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="Grid Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="Grid Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="Grid Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="Grid Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="Grid Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="Grid Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="Grid Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="46" Name="List Table 1 Light"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark"/>
  <w:LsdException Locked="false" Priority="51" Name="List Table 6 Colorful"/>
  <w:LsdException Locked="false" Priority="52" Name="List Table 7 Colorful"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 1"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 1"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 1"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 1"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 1"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 1"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 2"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 2"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 2"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 2"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 2"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 2"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 3"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 3"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 3"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 3"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 3"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 3"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 4"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 4"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 4"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 4"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 4"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 4"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 5"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 5"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 5"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 5"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 5"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 5"/>
  <w:LsdException Locked="false" Priority="46"
   Name="List Table 1 Light Accent 6"/>
  <w:LsdException Locked="false" Priority="47" Name="List Table 2 Accent 6"/>
  <w:LsdException Locked="false" Priority="48" Name="List Table 3 Accent 6"/>
  <w:LsdException Locked="false" Priority="49" Name="List Table 4 Accent 6"/>
  <w:LsdException Locked="false" Priority="50" Name="List Table 5 Dark Accent 6"/>
  <w:LsdException Locked="false" Priority="51"
   Name="List Table 6 Colorful Accent 6"/>
  <w:LsdException Locked="false" Priority="52"
   Name="List Table 7 Colorful Accent 6"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Hyperlink"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Hashtag"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Unresolved Mention"/>
  <w:LsdException Locked="false" SemiHidden="true" UnhideWhenUsed="true"
   Name="Smart Link"/>
 </w:LatentStyles>
</xml><![endif]-->
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:Wingdings;
	panose-1:5 0 0 0 0 0 0 0 0 0;
	mso-font-charset:2;
	mso-generic-font-family:auto;
	mso-font-pitch:variable;
	mso-font-signature:0 268435456 0 0 -2147483648 0;}
@font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;
	mso-font-charset:0;
	mso-generic-font-family:roman;
	mso-font-pitch:variable;
	mso-font-signature:-536869121 1107305727 33554432 0 415 0;}
@font-face
	{font-family:"Trebuchet MS";
	panose-1:2 11 6 3 2 2 2 2 2 4;
	mso-font-alt:"Trebuchet MS";
	mso-font-charset:0;
	mso-generic-font-family:swiss;
	mso-font-pitch:variable;
	mso-font-signature:1671 0 0 0 159 0;}
@font-face
	{font-family:Aptos;
	mso-font-charset:0;
	mso-generic-font-family:swiss;
	mso-font-pitch:variable;
	mso-font-signature:536871559 3 0 0 415 0;}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-parent:"";
	margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
h1
	{mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Heading 1 Char";
	mso-style-next:Normal;
	margin-top:.25in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:1;
	text-autospace:none;
	font-size:20.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-font-kerning:0pt;
	mso-ansi-language:FR;
	font-weight:normal;}
h2
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 2 Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:2;
	text-autospace:none;
	font-size:16.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h3
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 3 Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:3;
	text-autospace:none;
	font-size:14.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h4
	{mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 4 Char";
	mso-style-next:Normal;
	margin-top:4.0pt;
	margin-right:0in;
	margin-bottom:2.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:4;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;
	font-style:italic;}
h5
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 5 Char";
	mso-style-next:Normal;
	margin-top:4.0pt;
	margin-right:0in;
	margin-bottom:2.0pt;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:5;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-weight:normal;}
h6
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 6 Char";
	mso-style-next:Normal;
	margin-top:2.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:6;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	mso-ansi-language:FR;
	font-weight:normal;
	font-style:italic;}
p.MsoHeading7, li.MsoHeading7, div.MsoHeading7
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 7 Char";
	mso-style-next:Normal;
	margin-top:2.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:7;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	mso-ansi-language:FR;}
p.MsoHeading8, li.MsoHeading8, div.MsoHeading8
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 8 Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:8;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	mso-ansi-language:FR;
	font-style:italic;}
p.MsoHeading9, li.MsoHeading9, div.MsoHeading9
	{mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-qformat:yes;
	mso-style-link:"Heading 9 Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:lines-together;
	page-break-after:avoid;
	mso-outline-level:9;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	mso-ansi-language:FR;}
p.MsoHeader, li.MsoHeader, div.MsoHeader
	{mso-style-priority:99;
	mso-style-link:"Header Char";
	margin:0in;
	mso-pagination:none;
	tab-stops:center 3.15in right 6.3in;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoFooter, li.MsoFooter, div.MsoFooter
	{mso-style-priority:99;
	mso-style-link:"Footer Char";
	margin:0in;
	mso-pagination:none;
	tab-stops:center 3.15in right 6.3in;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoTitle, li.MsoTitle, div.MsoTitle
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpFirst, li.MsoTitleCxSpFirst, div.MsoTitleCxSpFirst
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpMiddle, li.MsoTitleCxSpMiddle, div.MsoTitleCxSpMiddle
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoTitleCxSpLast, li.MsoTitleCxSpLast, div.MsoTitleCxSpLast
	{mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Title Char";
	mso-style-next:Normal;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:4.0pt;
	margin-left:0in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;
	mso-ansi-language:FR;}
p.MsoBodyText, li.MsoBodyText, div.MsoBodyText
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Body Text Char";
	margin-top:.05pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:28.3pt;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoSubtitle, li.MsoSubtitle, div.MsoSubtitle
	{mso-style-priority:11;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Subtitle Char";
	mso-style-next:Normal;
	margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:14.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	letter-spacing:.75pt;
	mso-ansi-language:FR;}
a:link, span.MsoHyperlink
	{mso-style-priority:99;
	color:#467886;
	mso-themecolor:hyperlink;
	text-decoration:underline;
	text-underline:single;}
a:visited, span.MsoHyperlinkFollowed
	{mso-style-noshow:yes;
	mso-style-priority:99;
	color:#96607D;
	mso-themecolor:followedhyperlink;
	text-decoration:underline;
	text-underline:single;}
p.MsoListParagraph, li.MsoListParagraph, div.MsoListParagraph
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpFirst, li.MsoListParagraphCxSpFirst, div.MsoListParagraphCxSpFirst
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpMiddle, li.MsoListParagraphCxSpMiddle, div.MsoListParagraphCxSpMiddle
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoListParagraphCxSpLast, li.MsoListParagraphCxSpLast, div.MsoListParagraphCxSpLast
	{mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-type:export-only;
	margin-top:0in;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:.5in;
	mso-add-space:auto;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
p.MsoQuote, li.MsoQuote, div.MsoQuote
	{mso-style-priority:29;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Quote Char";
	mso-style-next:Normal;
	margin-top:8.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:0in;
	text-align:center;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	color:#404040;
	mso-themecolor:text1;
	mso-themetint:191;
	mso-ansi-language:FR;
	font-style:italic;}
p.MsoIntenseQuote, li.MsoIntenseQuote, div.MsoIntenseQuote
	{mso-style-priority:30;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	mso-style-link:"Intense Quote Char";
	mso-style-next:Normal;
	margin-top:.25in;
	margin-right:.6in;
	margin-bottom:.25in;
	margin-left:.6in;
	text-align:center;
	mso-pagination:none;
	text-autospace:none;
	border:none;
	mso-border-top-alt:solid #0F4761 .5pt;
	mso-border-top-themecolor:accent1;
	mso-border-top-themeshade:191;
	mso-border-bottom-alt:solid #0F4761 .5pt;
	mso-border-bottom-themecolor:accent1;
	mso-border-bottom-themeshade:191;
	padding:0in;
	mso-padding-alt:10.0pt 0in 10.0pt 0in;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	mso-ansi-language:FR;
	font-style:italic;}
span.MsoIntenseEmphasis
	{mso-style-priority:21;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.MsoIntenseReference
	{mso-style-priority:32;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	font-variant:small-caps;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	letter-spacing:.25pt;
	font-weight:bold;}
span.Heading1Char
	{mso-style-name:"Heading 1 Char";
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 1";
	mso-ansi-font-size:20.0pt;
	mso-bidi-font-size:20.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading2Char
	{mso-style-name:"Heading 2 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 2";
	mso-ansi-font-size:16.0pt;
	mso-bidi-font-size:16.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading3Char
	{mso-style-name:"Heading 3 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 3";
	mso-ansi-font-size:14.0pt;
	mso-bidi-font-size:14.0pt;
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading4Char
	{mso-style-name:"Heading 4 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 4";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.Heading5Char
	{mso-style-name:"Heading 5 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 5";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;}
span.Heading6Char
	{mso-style-name:"Heading 6 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 6";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	font-style:italic;}
span.Heading7Char
	{mso-style-name:"Heading 7 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 7";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;}
span.Heading8Char
	{mso-style-name:"Heading 8 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 8";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;
	font-style:italic;}
span.Heading9Char
	{mso-style-name:"Heading 9 Char";
	mso-style-noshow:yes;
	mso-style-priority:9;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Heading 9";
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#272727;
	mso-themecolor:text1;
	mso-themetint:216;}
span.TitleChar
	{mso-style-name:"Title Char";
	mso-style-priority:10;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Title;
	mso-ansi-font-size:28.0pt;
	mso-bidi-font-size:28.0pt;
	font-family:"Aptos Display",sans-serif;
	mso-ascii-font-family:"Aptos Display";
	mso-ascii-theme-font:major-latin;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-hansi-font-family:"Aptos Display";
	mso-hansi-theme-font:major-latin;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	letter-spacing:-.5pt;
	mso-font-kerning:14.0pt;}
span.SubtitleChar
	{mso-style-name:"Subtitle Char";
	mso-style-priority:11;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Subtitle;
	mso-ansi-font-size:14.0pt;
	mso-bidi-font-size:14.0pt;
	font-family:"Times New Roman",serif;
	mso-fareast-font-family:"Times New Roman";
	mso-fareast-theme-font:major-fareast;
	mso-bidi-font-family:"Times New Roman";
	mso-bidi-theme-font:major-bidi;
	color:#595959;
	mso-themecolor:text1;
	mso-themetint:166;
	letter-spacing:.75pt;}
span.QuoteChar
	{mso-style-name:"Quote Char";
	mso-style-priority:29;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Quote;
	color:#404040;
	mso-themecolor:text1;
	mso-themetint:191;
	font-style:italic;}
span.IntenseQuoteChar
	{mso-style-name:"Intense Quote Char";
	mso-style-priority:30;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Intense Quote";
	color:#0F4761;
	mso-themecolor:accent1;
	mso-themeshade:191;
	font-style:italic;}
span.BodyTextChar
	{mso-style-name:"Body Text Char";
	mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:"Body Text";
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
p.TableParagraph, li.TableParagraph, div.TableParagraph
	{mso-style-name:"Table Paragraph";
	mso-style-priority:1;
	mso-style-unhide:no;
	mso-style-qformat:yes;
	margin-top:5.0pt;
	margin-right:0in;
	margin-bottom:0in;
	margin-left:1.0pt;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-ansi-language:FR;}
span.HeaderChar
	{mso-style-name:"Header Char";
	mso-style-priority:99;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Header;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
span.FooterChar
	{mso-style-name:"Footer Char";
	mso-style-priority:99;
	mso-style-unhide:no;
	mso-style-locked:yes;
	mso-style-link:Footer;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-ascii-font-family:"Trebuchet MS";
	mso-fareast-font-family:"Trebuchet MS";
	mso-hansi-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	mso-font-kerning:0pt;
	mso-ligatures:none;}
span.SpellE
	{mso-style-name:"";
	mso-spl-e:yes;}
span.GramE
	{mso-style-name:"";
	mso-gram-e:yes;}
.MsoChpDefault
	{mso-style-type:export-only;
	mso-default-props:yes;
	font-size:12.0pt;
	mso-ansi-font-size:12.0pt;
	mso-bidi-font-size:12.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-fareast-font-family:Aptos;
	mso-fareast-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;
	mso-bidi-font-family:Arial;
	mso-bidi-theme-font:minor-bidi;
	mso-ansi-language:FR;}
.MsoPapDefault
	{mso-style-type:export-only;
	margin-bottom:8.0pt;
	line-height:115%;}
 /* Page Definitions */
 @page
	{mso-footnote-separator:url("terms_condition_files/header.htm") fs;
	mso-footnote-continuation-separator:url("terms_condition_files/header.htm") fcs;
	mso-endnote-separator:url("terms_condition_files/header.htm") es;
	mso-endnote-continuation-separator:url("terms_condition_files/header.htm") ecs;}
@page WordSection1
	{size:595.5pt 842.0pt;
	margin:66.0pt 42.5pt 47.0pt 42.5pt;
	mso-header-margin:0in;
	mso-footer-margin:37.4pt;
	border:solid #747474 1.5pt;
	padding:20.0pt 16.0pt 23.0pt 14.0pt;
	mso-footer:url("terms_condition_files/header.htm") f1;
	mso-paper-source:0;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 @list l0
	{mso-list-id:65345066;
	mso-list-type:hybrid;
	mso-list-template-ids:-2132766678 481063848 67895299 67895301 67895297 67895299 67895301 67895297 67895299 67895301;}
@list l0:level1
	{mso-level-start-at:4;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:46.3pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";}
@list l0:level2
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level3
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:118.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l0:level4
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:154.3pt;
	text-indent:-.25in;
	font-family:Symbol;}
@list l0:level5
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:190.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level6
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:226.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l0:level7
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:262.3pt;
	text-indent:-.25in;
	font-family:Symbol;}
@list l0:level8
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:298.3pt;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l0:level9
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:334.3pt;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l1
	{mso-list-id:75252490;
	mso-list-template-ids:581487838;}
@list l1:level1
	{mso-level-start-at:4;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level2
	{mso-level-start-at:3;
	mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-20.4pt;
	mso-ansi-font-size:12.0pt;
	mso-bidi-font-size:12.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l1:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:163.15pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:212.75pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:262.35pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:311.95pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:361.5pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l1:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:411.1pt;
	text-indent:-20.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2
	{mso-list-id:144013986;
	mso-list-type:hybrid;
	mso-list-template-ids:-83202504 -375365978 -1949528154 1340512296 -1238759444 765499220 -535024728 299673496 410431232 392327426;}
@list l2:level1
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-.25in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l2:level2
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:100.3pt;
	text-indent:-.5in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l2:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:145.55pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:191.15pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:236.75pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:282.35pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:327.95pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:373.5pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l2:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:419.1pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3
	{mso-list-id:302586870;
	mso-list-type:hybrid;
	mso-list-template-ids:-855719610 1081741136 -533941608 593134594 -857947172 1322008396 -1179731494 1475742350 1240379596 357714874;}
@list l3:level1
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:34.65pt;
	text-indent:-6.4pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l3:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.5pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:130.05pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:177.55pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:225.1pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:272.65pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:320.15pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:367.7pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l3:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:415.25pt;
	text-indent:-6.4pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l4
	{mso-list-id:845291412;
	mso-list-type:hybrid;
	mso-list-template-ids:1133918808 481063848 67895299 67895301 67895297 67895299 67895301 67895297 67895299 67895301;}
@list l4:level1
	{mso-level-start-at:4;
	mso-level-number-format:bullet;
	mso-level-text:-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:53.45pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";}
@list l4:level2
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level3
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l4:level4
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Symbol;}
@list l4:level5
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level6
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l4:level7
	{mso-level-number-format:bullet;
	mso-level-text:\F0B7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Symbol;}
@list l4:level8
	{mso-level-number-format:bullet;
	mso-level-text:o;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:"Courier New";}
@list l4:level9
	{mso-level-number-format:bullet;
	mso-level-text:\F0A7;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	text-indent:-.25in;
	font-family:Wingdings;}
@list l5
	{mso-list-id:951015993;
	mso-list-type:hybrid;
	mso-list-template-ids:40894972 -2034321484 519206196 -569575802 1051516998 -1960307128 1359479974 -1627613710 229526434 506101588;}
@list l5:level1
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-.25in;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l5:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:108.6pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:153.25pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:197.85pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:242.5pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:287.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:331.75pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:376.4pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l5:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:421.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6
	{mso-list-id:1119107937;
	mso-list-template-ids:1536082450;}
@list l6:level1
	{mso-level-start-at:4;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level2
	{mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level3
	{mso-level-start-at:5;
	mso-level-text:"%1\.%2\.%3";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:64.3pt;
	text-indent:-27.25pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l6:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:197.85pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:242.5pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:287.15pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:331.75pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:376.4pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l6:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:421.05pt;
	text-indent:-27.25pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7
	{mso-list-id:1556769011;
	mso-list-type:hybrid;
	mso-list-template-ids:231362116 76955280 -1872831298 -78199902 -1493786652 1900572830 -1114967158 -1342291872 899712228 -982057908;}
@list l7:level1
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text:25CF;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:100.3pt;
	text-indent:-.25in;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:0pt;
	mso-font-width:124%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level2
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:141.0pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level3
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:182.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:223.05pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:264.1pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:305.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:346.15pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:387.2pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l7:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:428.25pt;
	text-indent:-.25in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8
	{mso-list-id:1658344737;
	mso-list-template-ids:511499126;}
@list l8:level1
	{mso-level-start-at:6;
	mso-level-text:%1;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level2
	{mso-level-text:"%1\.%2";
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:28.3pt;
	text-indent:-17.9pt;
	mso-ansi-font-size:11.5pt;
	mso-bidi-font-size:11.5pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.1pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:normal;
	mso-bidi-font-weight:normal;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l8:level3
	{mso-level-number-format:alpha-upper;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:136.3pt;
	text-indent:-.5in;
	mso-ansi-font-size:11.0pt;
	mso-bidi-font-size:11.0pt;
	font-family:"Trebuchet MS",sans-serif;
	mso-fareast-font-family:"Trebuchet MS";
	mso-bidi-font-family:"Trebuchet MS";
	letter-spacing:-.05pt;
	mso-font-width:92%;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;
	mso-ansi-font-weight:bold;
	mso-bidi-font-weight:bold;
	mso-ansi-font-style:normal;
	mso-bidi-font-style:normal;}
@list l8:level4
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:219.15pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level5
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:260.75pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level6
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:302.35pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level7
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:343.95pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level8
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:385.5pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l8:level9
	{mso-level-start-at:0;
	mso-level-number-format:bullet;
	mso-level-text: ;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:427.1pt;
	text-indent:-.5in;
	mso-ansi-language:FR;
	mso-fareast-language:EN-US;
	mso-bidi-language:AR-SA;}
@list l9
	{mso-list-id:1742099668;
	mso-list-type:hybrid;
	mso-list-template-ids:-956401252 1822617726 67895321 67895323 67895311 67895321 67895323 67895311 67895321 67895323;}
@list l9:level1
	{mso-level-start-at:3;
	mso-level-text:%1-;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:82.3pt;
	text-indent:-.25in;}
@list l9:level2
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:118.3pt;
	text-indent:-.25in;}
@list l9:level3
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:154.3pt;
	text-indent:-9.0pt;}
@list l9:level4
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:190.3pt;
	text-indent:-.25in;}
@list l9:level5
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:226.3pt;
	text-indent:-.25in;}
@list l9:level6
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:262.3pt;
	text-indent:-9.0pt;}
@list l9:level7
	{mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:298.3pt;
	text-indent:-.25in;}
@list l9:level8
	{mso-level-number-format:alpha-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:left;
	margin-left:334.3pt;
	text-indent:-.25in;}
@list l9:level9
	{mso-level-number-format:roman-lower;
	mso-level-tab-stop:none;
	mso-level-number-position:right;
	margin-left:370.3pt;
	text-indent:-9.0pt;}
ol
	{margin-bottom:0in;}
ul
	{margin-bottom:0in;}
-->
</style>
<!--[if gte mso 10]>
<style>
 /* Style Definitions */
 table.MsoNormalTable
	{mso-style-name:"Table Normal";
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-noshow:yes;
	mso-style-priority:99;
	mso-style-parent:"";
	mso-padding-alt:0in 5.4pt 0in 5.4pt;
	mso-para-margin-top:0in;
	mso-para-margin-right:0in;
	mso-para-margin-bottom:8.0pt;
	mso-para-margin-left:0in;
	line-height:115%;
	mso-pagination:widow-orphan;
	font-size:12.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;
	mso-font-kerning:1.0pt;
	mso-ligatures:standardcontextual;
	mso-ansi-language:FR;}
table.TableNormal1
	{mso-style-name:"Table Normal1";
	mso-tstyle-rowband-size:0;
	mso-tstyle-colband-size:0;
	mso-style-noshow:yes;
	mso-style-priority:2;
	mso-style-qformat:yes;
	mso-style-parent:"";
	mso-padding-alt:0in 0in 0in 0in;
	mso-para-margin:0in;
	mso-pagination:none;
	text-autospace:none;
	font-size:11.0pt;
	font-family:"Aptos",sans-serif;
	mso-ascii-font-family:Aptos;
	mso-ascii-theme-font:minor-latin;
	mso-hansi-font-family:Aptos;
	mso-hansi-theme-font:minor-latin;}
</style>
<![endif]--><!--[if gte mso 9]><xml>
 <o:shapedefaults v:ext="edit" spidmax="1027"/>
</xml><![endif]--><!--[if gte mso 9]><xml>
 <o:shapelayout v:ext="edit">
  <o:idmap v:ext="edit" data="1"/>
 </o:shapelayout></xml><![endif]-->
</head>

<body lang=EN-US link="#467886" vlink="#96607D" style='tab-interval:35.4pt;
word-wrap:break-word'>

<div class=WordSection1>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>PR SENTATION</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ET</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>PRINCIPE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>DU</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>JEU<o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Football</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>plateforme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>permet</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>aux</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>utilisateurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jouer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>ligne</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>rejoindre
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>un<span style='letter-spacing:-1.0pt'> </span>Championnat<span
style='letter-spacing:-1.0pt'> </span>en<span style='letter-spacing:-1.0pt'> </span>s lectionnant<span
style='letter-spacing:-.9pt'> </span>11<span style='letter-spacing:-.95pt'> </span>footballeurs<span
style='letter-spacing:-.85pt'> </span> voluant<span style='letter-spacing:-1.0pt'>
</span>dans<span style='letter-spacing:-.85pt'> </span>la<span
style='letter-spacing:-1.0pt'> </span>ligue<span style='letter-spacing:-.75pt'>
</span>Choisie,<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l utilisateur</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>collecte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>points</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fonction</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>performances</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r elles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>joueurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>concourt<span style='letter-spacing:2.0pt'> </span>au
fil<span style='letter-spacing:-.05pt'> </span>des<span style='letter-spacing:
-.2pt'> </span>matchs disput s.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Football<span style='letter-spacing:-.75pt'> </span>fantasy<span
style='letter-spacing:-.95pt'> </span>est<span style='letter-spacing:-.9pt'> </span>un<span
style='letter-spacing:-.85pt'> </span>jeu<span style='letter-spacing:1.95pt'> </span>d'abonnement<span
style='letter-spacing:-.9pt'> </span>Web<span style='letter-spacing:-1.0pt'> </span>disponible<span
style='letter-spacing:-.85pt'> </span>pour<span style='letter-spacing:-.8pt'> </span>les<span
style='letter-spacing:-.9pt'> </span>abonn s<span style='letter-spacing:-.9pt'>
</span>mobiles<span style='letter-spacing:-.6pt'> </span>en <span
style='letter-spacing:-.2pt'>Tunisie.<o:p></o:p></span></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ARTICLE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>3</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DATE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ET</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DUREE</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DU</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>JEU<o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-indent:
2.4pt'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><b style='mso-bidi-font-weight:normal'><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Football</span></b><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fantasy</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span></b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>est</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>accessible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>moment</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pendant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>p riode</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du
<b><span style='color:black'>25/09/2025</span></b></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>partir</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.05pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>00.00.00</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>se</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>termine</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.9pt'> </span><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>23/12</span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>/2025</span></b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.95pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.2pt'>23.59.59.</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:66.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dur e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>totale</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:.2pt'> </span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>90</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.3pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jours<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:66.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>ARTICLE<span style='letter-spacing:-1.2pt'> </span>4<span
style='letter-spacing:-1.05pt'> </span>:<span style='letter-spacing:-1.15pt'> </span>MODE<span
style='letter-spacing:-1.15pt'> </span>DE<span style='letter-spacing:-1.05pt'> </span><span
style='letter-spacing:-.1pt'>PARTICIPATION<o:p></o:p></span></span></h1>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ouvert</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tous</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>abonn s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Tunisie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sauf</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>celles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>cit es</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'article
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>5 du pr sent r glement.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>obligation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d achat.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>service</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disponible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>canaux,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>comme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d crit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ci-
</span><span class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>dessous:</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>En<span style='letter-spacing:-.45pt'> </span>composant<span
style='letter-spacing:-.4pt'> </span>le<span style='letter-spacing:-.35pt'> </span>code<span
style='letter-spacing:-.35pt'> </span>USSD<span style='letter-spacing:-.4pt'> </span><b>*898*2#<o:p></o:p></b></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>En</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>envoyant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>contenant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mot</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>cl </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>  &nbsp;</span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Fantasy</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>&nbsp; </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>85881</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:100.3pt;mso-add-space:
auto;text-indent:-.5in;mso-list:l2 level2 lfo7;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.05pt;mso-font-width:92%'><span
style='mso-list:Ignore'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>En</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>acc dant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l URL</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR><a href="https://tt.ffeleven.com/"><span style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.2pt'>https://tt.ffeleven.com</span></a></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='tab-stops:100.3pt'><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Une</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fois</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'inscription</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>r ussie,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>clients</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevront</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>message</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>bienvenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>m me
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>num ro<span style='letter-spacing:-.9pt'> </span>court<span
style='letter-spacing:-.95pt'> </span>85881<span style='letter-spacing:-.8pt'> </span>qui<span
style='letter-spacing:-1.0pt'> </span>comprend<span style='letter-spacing:-.85pt'>
</span>des<span style='letter-spacing:-.8pt'> </span>informations<span
style='letter-spacing:-.8pt'> </span>sur<span style='letter-spacing:-.9pt'> </span>le<span
style='letter-spacing:-.8pt'> </span><span class=GramE>jeu<span
style='letter-spacing:-.7pt'> </span>.</span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>En</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>s abonnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:1.45pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>acceptent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>comprennent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>conditions<span style='letter-spacing:-1.0pt'>
</span>g n rales<span style='letter-spacing:-.85pt'> </span>compl tes<span
style='letter-spacing:-1.05pt'> </span>et<span style='letter-spacing:-1.05pt'> </span>acceptent
de&nbsp;:<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:77.45pt;margin-bottom:
0in;margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-align:
justify;text-indent:-.25in;mso-list:l0 level1 lfo8;tab-stops:64.3pt'><![if !supportLists]><span
lang=FR><span style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Recevoir<span style='letter-spacing:-1.05pt'> </span>un<span
style='letter-spacing:-.95pt'> </span>message<span style='letter-spacing:-1.0pt'>
</span>de<span style='letter-spacing:-.85pt'> </span>bienvenue <span
style='letter-spacing:-.3pt'>comprenant</span><span style='letter-spacing:-1.2pt'>
</span><span style='letter-spacing:-.3pt'>un</span><span style='letter-spacing:
-1.2pt'> </span><span style='letter-spacing:-.3pt'>lien</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.3pt'>vers</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.3pt'>le</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.3pt'>portail</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.3pt'>Web</span><span
style='letter-spacing:-1.05pt'> </span></span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.3pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:#467885;letter-spacing:-1.0pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>en</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>provenance</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>85881 sur leurs t l phones mobiles.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:77.45pt;margin-bottom:
0in;margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto;text-indent:
-.25in;mso-list:l0 level1 lfo8;tab-stops:64.3pt'><![if !supportLists]><span
lang=FR><span style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Recevoir</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>code</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>v rification</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>soumis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>portail</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>but</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>compl ter<span style='letter-spacing:-.45pt'> </span>la<span
style='letter-spacing:-.4pt'> </span>confirmation<span style='letter-spacing:
-.25pt'> </span>d'abonnement<o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:77.45pt;mso-add-space:auto;tab-stops:
64.3pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.3pt'>Pour</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jouer,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>doit</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>se</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>connecter</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>site</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>saisir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>son</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>num ro </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>mobile</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>code</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d authentification</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re u</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>SMS</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>puis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>cliquer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>bouton</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>JOUER
</span><span class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>MAINTENANT </span></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'>Le 3<sup> </sup>premier jours d abonnement <span
class=GramE>sont<span style='mso-spacerun:yes'>  </span>gratuits</span> ,  </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.35pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>quatri me </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>co t</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sera</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>0,700</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DT</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>TTC</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoNormal style='margin-right:44.3pt;mso-add-space:auto;tab-stops:
64.3pt 66.7pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'>Tant</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>reste</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>actif,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.35pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>peut</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>profiter</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les
fonctionnalit s.</span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Lors</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'inscription,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re oit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>message</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>bienvenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>contenant
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d tails</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span class=GramE><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>jeu</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>,</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>comprend</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lien</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>web
football</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>fantasy</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>connecter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>automatiquement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'aide</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>identifiants.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Les
clients</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>peuvent</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>profiter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du
jeu en</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>utilisant</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>leur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>activ 
automatiquement</span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevra</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>budget</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>virtuel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>80</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>unit s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pour
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>constituer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> quipe</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>web</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:1.8pt'> </span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:#467885;letter-spacing:-.2pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:89.8pt;margin-bottom:
0in;margin-left:0in;margin-bottom:.0001pt;mso-add-space:auto;text-align:justify'><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Le</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>s'engage</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevoir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>offres
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>promotionnelles<span style='letter-spacing:
-.9pt'> </span>de<span style='letter-spacing:-.9pt'> </span>l'Organisateur<span
style='letter-spacing:-1.0pt'> </span>sur<span style='letter-spacing:-1.0pt'> </span>son<span
style='letter-spacing:-.95pt'> </span>t l phone<span style='letter-spacing:
-.9pt'> </span>portable.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Tout</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><b><u><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>nouvel</span></u></b><b><u><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span></u></b><b><u><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>abonn </span></u></b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>b n ficie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jours</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>gratuit.
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>L abonnement au <span
class=GramE>jeu <span style='letter-spacing:-1.15pt'><span
style='mso-spacerun:yes'> </span></span>est</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>factur </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>client</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>0.7</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>DT/Jour
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'><span
style='mso-spacerun:yes'> </span></span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>quatri me</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p></o:p></span></p>

<h4 style='margin-top:0in;margin-right:57.5pt;margin-bottom:2.0pt;margin-left:
64.3pt;mso-add-space:auto;tab-stops:91.45pt'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>L abonnement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>renouvelable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>automatiquement.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>Chaque</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>renouvellement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>r ussie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>factur </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>attribuera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.4pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l utilisateur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><b><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;color:black;
letter-spacing:-.3pt'>un</span></b><b><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black;letter-spacing:-.65pt'> </span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.3pt'>budget</span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.65pt'> </span></b><b><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:-.3pt'>virtuel </span></b><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black'> gale<span style='letter-spacing:-.8pt'> </span> <span
style='letter-spacing:-.95pt'> </span>0.5<span style='letter-spacing:-.8pt'> </span>Unit </span></b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black;letter-spacing:1.75pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;color:black'> <span style='letter-spacing:-.95pt'> </span>son<span
style='letter-spacing:-.85pt'> </span>compte<span style='letter-spacing:-.9pt'>
</span>football<span style='letter-spacing:-.95pt'> </span>fantasy<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.85pt;margin-bottom:
0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:53.8pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Tous</span><span lang=FR style='font-size:
11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>messages</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>promotionnels</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>li s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>envoy </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>aux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participants</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sont gratuits.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:53.8pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:35.7pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Le</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>doit</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.3pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>v rifier</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>num ro</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>t l phone</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>portable</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>utilis </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pour </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participer</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>correct</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>exact.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Ainsi,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>signant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>formulaire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d'abonnement, </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>confirme</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>num ro</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>t l phone</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>utilis </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sien,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>celui</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>dont</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>personnellement<span style='letter-spacing:
-.75pt'> </span>responsable.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-top:0in;margin-right:35.7pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:91.45pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>L'abonn </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>accepte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> galement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>recevoir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>alertes</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>SMS,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>offres</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>publicitaires,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toute</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>autre</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>campagne</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l'Organisateur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>t l phone</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>mobile</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>en
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>lien avec le jeu.<o:p></o:p></span></p>

<p class=MsoListParagraph style='margin-top:0in;margin-right:33.6pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;tab-stops:46.1pt'><!--[if gte vml 1]><v:shapetype
 id="_x0000_t75" coordsize="21600,21600" o:spt="75" o:preferrelative="t"
 path="m@4@5l@4@11@9@11@9@5xe" filled="f" stroked="f">
 <v:stroke joinstyle="miter"/>
 <v:formulas>
  <v:f eqn="if lineDrawn pixelLineWidth 0"/>
  <v:f eqn="sum @0 1 0"/>
  <v:f eqn="sum 0 0 @1"/>
  <v:f eqn="prod @2 1 2"/>
  <v:f eqn="prod @3 21600 pixelWidth"/>
  <v:f eqn="prod @3 21600 pixelHeight"/>
  <v:f eqn="sum @0 0 1"/>
  <v:f eqn="prod @6 1 2"/>
  <v:f eqn="prod @7 21600 pixelWidth"/>
  <v:f eqn="sum @8 21600 0"/>
  <v:f eqn="prod @7 21600 pixelHeight"/>
  <v:f eqn="sum @10 21600 0"/>
 </v:formulas>
 <v:path o:extrusionok="f" gradientshapeok="t" o:connecttype="rect"/>
 <o:lock v:ext="edit" aspectratio="t"/>
</v:shapetype><v:shape id="Image_x0020_2" o:spid="_x0000_s1026" type="#_x0000_t75"
 style='position:absolute;left:0;text-align:left;margin-left:332.65pt;
 margin-top:6.5pt;width:9.2pt;height:9.05pt;z-index:251659264;visibility:visible;
 mso-wrap-style:square;mso-wrap-distance-left:0;mso-wrap-distance-top:0;
 mso-wrap-distance-right:0;mso-wrap-distance-bottom:0;
 mso-position-horizontal:absolute;mso-position-horizontal-relative:page;
 mso-position-vertical:absolute;mso-position-vertical-relative:text'>
 <v:imagedata src="terms_condition_files/image001.png" o:title=""/>
 <o:lock v:ext="edit" aspectratio="f"/>
 <w:wrap anchorx="page"/>
</v:shape><![endif]--><![if !vml]><span style='mso-ignore:vglayout;position:
absolute;z-index:251659264;left:0px;margin-left:562px;margin-top:430px;
width:15px;height:15px'><img width=12 height=12
src="terms_condition_files/image002.png" v:shapes="Image_x0020_2"></span><![endif]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le<span style='letter-spacing:-1.05pt'> </span>participant<span
style='letter-spacing:-1.05pt'> </span>accepte<span style='letter-spacing:-1.0pt'>
</span> <span style='letter-spacing:-1.2pt'> </span>l'avance,<span
style='letter-spacing:-1.15pt'> </span>de<span style='letter-spacing:-1.05pt'> </span>recevoir<span
style='letter-spacing:-1.25pt'> </span>des<span style='letter-spacing:-1.05pt'>
</span>SMS<span style='letter-spacing:-1.25pt'> </span>au<span
style='letter-spacing:-1.2pt'> </span>num ro<span style='letter-spacing:-1.25pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>t l phone<span
style='letter-spacing:-1.15pt'> </span>qu'il<span style='letter-spacing:-1.1pt'>
</span>a utilis <span style='letter-spacing:-1.05pt'> </span>pour<span
style='letter-spacing:-1.25pt'> </span>s'abonner<span style='letter-spacing:
-1.15pt'> </span>au<span style='letter-spacing:-1.2pt'> </span>jeu,<span
style='letter-spacing:-1.15pt'> </span>y<span style='letter-spacing:-1.15pt'> </span>compris,<span
style='letter-spacing:-1.15pt'> </span>mais<span style='letter-spacing:-1.15pt'>
</span>sans<span style='letter-spacing:-1.05pt'> </span>s'y<span
style='letter-spacing:-1.2pt'> </span>limiter<span style='letter-spacing:-1.25pt'>
</span>:<span style='letter-spacing:-1.15pt'> </span>Des<span style='letter-spacing:
-1.2pt'> </span>messages,<span style='letter-spacing:-1.15pt'> </span>qu'il<span
style='letter-spacing:-1.25pt'> </span>s'agisse d'alertes,<span
style='letter-spacing:-1.15pt'> </span>de<span style='letter-spacing:-1.05pt'> </span>notifications,<span
style='letter-spacing:-1.15pt'> </span>des<span style='letter-spacing:-1.15pt'>
</span>derni res<span style='letter-spacing:-1.15pt'> </span>mises<span
style='letter-spacing:-1.2pt'> </span> <span style='letter-spacing:-1.2pt'> </span>jour,<span
style='letter-spacing:-1.15pt'> </span>des<span style='letter-spacing:-1.2pt'> </span>informations<span
style='letter-spacing:-1.15pt'> </span>sur<span style='letter-spacing:-1.1pt'> </span>le<span
style='letter-spacing:-1.05pt'> </span>compte<span style='letter-spacing:-1.05pt'>
</span>ou des<span style='letter-spacing:-.15pt'> </span>informations<span
style='letter-spacing:-.1pt'> </span>sur le<span style='letter-spacing:-.1pt'> </span>jeu.<o:p></o:p></span></p>

<p class=MsoNormal style='tab-stops:46.2pt'><span lang=FR style='font-size:
12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'><span style='mso-tab-count:
1'>                   </span>Le</span><span lang=FR style='font-size:12.0pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>peut</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>se</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d sinscrire</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>moment</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:28.2pt;
margin-bottom:0in;margin-left:64.3pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l1 level3 lfo4;tab-stops:64.3pt 66.65pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span class=GramE><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>en</span></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>envoyant<span style='letter-spacing:
-.85pt'> </span><b style='mso-bidi-font-weight:normal'>GRATUITEMENT<span
style='letter-spacing:-.75pt'> </span></b>la<span style='letter-spacing:-.9pt'>
</span>commande<span style='letter-spacing:-.85pt'> </span> <span
style='letter-spacing:-.95pt'> </span><b style='mso-bidi-font-weight:normal'>STOP<span
style='letter-spacing:-.9pt'> </span>FF</b> <span style='letter-spacing:-.85pt'>
</span>au<span style='letter-spacing:-.85pt'> </span>num ro<span
style='letter-spacing:-.9pt'> </span><b>85881.<span style='letter-spacing:-.85pt'>
</span></b><span class=GramE>il</span><span style='letter-spacing:-.85pt'> </span>ne
recevra<span style='letter-spacing:-.05pt'> </span>plus de messages SMS li s au
Jeu ,<span style='letter-spacing:-.05pt'> </span>la d sinscription n entraine
pas la remise   z ro du solde des points et la r inscription ne donne plus
droit   la <span style='letter-spacing:-.1pt'>gratuit .</span><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:64.25pt;mso-add-space:
auto;text-indent:-17.95pt;mso-list:l1 level3 lfo4;tab-stops:64.25pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Via</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>menu</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>USSD</span></b><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span></b><b><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>*898*3<span
class=GramE>#<span style='letter-spacing:-.75pt'> </span>,<span
style='font-weight:normal'>choix</span></span></span></b><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d sinscription</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Football</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>fantasy</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:64.25pt;mso-add-space:
auto;text-indent:-17.95pt;mso-list:l1 level3 lfo4;tab-stops:64.25pt'><![if !supportLists]><span
lang=FR style='font-size:12.0pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Via</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>le</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>portail</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>cliquant</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>d sinscrire</span><span
lang=FR style='font-size:12.0pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:64.25pt;mso-add-space:
auto;tab-stops:64.25pt'><span lang=FR style='font-size:12.0pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h1><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>ARTICLE<span style='letter-spacing:-1.15pt'> </span>5<span
style='letter-spacing:-1.05pt'> </span>:<span style='letter-spacing:-1.15pt'> </span>CONDITIONS<span
style='letter-spacing:-1.1pt'> </span>D' LIGIBILIT <span style='letter-spacing:
-1.0pt'> </span></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
20.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.5pt'>:</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:20.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p></o:p></span></h1>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Sont</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>exclus</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ce</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>personnel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>familles</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>personnel</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.35pt'>Tunisie</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>T l com</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span class=SpellE><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>Numbase</span></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:.3pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Tunisie</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:34.6pt;mso-add-space:
auto;text-indent:-6.3pt;mso-list:l3 level1 lfo3;tab-stops:34.6pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-font-width:92%'><span style='mso-list:Ignore'>-<span
style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.2pt'>Huissier</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>justice</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>notaire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>charg s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pr sent</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r glement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:34.6pt;mso-add-space:auto;
tab-stops:34.6pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h2 style='margin-top:0in;mso-add-space:auto;tab-stops:100.3pt'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>ARTICLE</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>6</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'> Date</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Syst me</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span class=GramE><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>r compense</span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:16.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>:</span></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:16.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></h2>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Chaque<span style='letter-spacing:-.95pt'> </span>semaine,<span
style='letter-spacing:-.95pt'> </span>les<span style='letter-spacing:-.95pt'> </span>participants<span
style='letter-spacing:-.9pt'> </span>au<span style='letter-spacing:-.95pt'> </span>jeu<span
style='letter-spacing:-.95pt'> </span>&quot;Football<span style='letter-spacing:
-.9pt'> </span>Fantasy&quot;<span style='letter-spacing:-.95pt'> </span>sont<span
style='letter-spacing:-.9pt'> </span>invit s<span style='letter-spacing:-1.0pt'>
</span> <span style='letter-spacing:-1.0pt'> </span>composer<span
style='letter-spacing:-1.05pt'> </span>leur <span style='letter-spacing:-.1pt'> quipe</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>et</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'> </span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>interagir</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>avec</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>jeu</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>pour</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>accumuler</span><span
style='letter-spacing:-1.35pt'> </span><span style='letter-spacing:-.1pt'>des</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>points.</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>Le</span><span
style='letter-spacing:1.15pt'> </span><span style='letter-spacing:-.1pt'>participant</span><span
style='letter-spacing:1.25pt'> </span><span style='letter-spacing:-.1pt'>ayant</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>obtenu</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>le </span><span
style='letter-spacing:-.2pt'>meilleur</span><span style='letter-spacing:-1.05pt'>
</span><span style='letter-spacing:-.2pt'>score</span><span style='letter-spacing:
-1.0pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>fin</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>semaine</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>remporte</span><span
style='letter-spacing:-.95pt'> </span><b><span style='letter-spacing:-.2pt'>le</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>prix</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>hebdomadaire</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>:1000
DTTC/championnat</span></b><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:29.4pt;
margin-bottom:0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:46.1pt'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Chaque</span><span lang=FR style='font-size:
11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>souscription</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>r ussie</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>booste</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>budget</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span></b><a
name="_Hlk209597509"><b><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:
11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>virtuel</span></b></a><span style='mso-bookmark:
_Hlk209597509'><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.7pt'> </span></span><span style='mso-bookmark:_Hlk209597509'></span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>l abonn </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>!</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Chaque</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jour,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>il</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>re oit </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>0,5</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>unit </span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> <b>virtuelles </b></span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>suppl mentaire</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>lui</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.55pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>permettant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>d investir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>strat giquement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>dans</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l'achat</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:2.0pt'> </span><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>de</span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>joueurs </span></b><b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>virtuels.</span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Plus</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>budget</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>grandit,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>plus</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>possibilit s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>victoire</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
class=GramE><span lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
letter-spacing:-.1pt'>augmentent</span><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>.</span></b></span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p></o:p></span></b></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:29.4pt;
margin-bottom:0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto;
tab-stops:46.1pt'><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoListParagraphCxSpLast style='margin-left:28.3pt;mso-add-space:auto;
text-indent:-17.9pt;mso-list:l8 level2 lfo2;tab-stops:136.2pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.1pt;mso-font-width:92%'><span
style='mso-list:Ignore'>6.1<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>M CANISME<span style='letter-spacing:-.75pt'> </span>DE<span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>NOTATION</span><o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:10.4pt;margin-bottom:.0001pt;mso-add-space:auto'><span class=GramE><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>L </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>attribution</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>points</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>fait</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>comme</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>suit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:46.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<div align=center>

<table class=TableNormal1 border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none;mso-border-alt:solid #9E9E9E .75pt;
 mso-yfti-tbllook:480;mso-padding-alt:0in 0in 0in 0in;mso-border-insideh:.75pt solid #9E9E9E;
 mso-border-insidev:.75pt solid #9E9E9E'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:3.25pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:3.25pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Footballeur</span></b><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></b></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border:solid #9E9E9E 1.0pt;
  border-left:none;mso-border-left-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:3.25pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Points</span></b><b
  style='mso-bidi-font-weight:normal'><span style='font-size:14.0pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></b></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:1;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>avoir</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.75pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>jou </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.85pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>jusqu' </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>60</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>minutes</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>1</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:2;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>avoir</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>jou </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>60</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>minutes</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>ou</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>plus</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>(hors</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>temps</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>d'arr t)</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>2</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:3;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.25pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>gardien</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>ou</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>d fenseur</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>6</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:4;height:15.55pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.55pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.2pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.75pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>milieu</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>de</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.65pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>terrain</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.55pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>5</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:5;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>but</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>marqu </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>par</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>un</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>attaquant</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>4</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:6;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'>Pour<span style='letter-spacing:-.5pt'> </span>claques<span
  style='letter-spacing:-.65pt'> </span>passe<span style='letter-spacing:-.55pt'>
  </span><span style='letter-spacing:-.1pt'>decisive</span><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.05pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.5pt;mso-ansi-language:EN-US'>3</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:7;height:15.45pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Pour</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>But</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>contre</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.8pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>son</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>camp</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.45pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'>-<span style='letter-spacing:-.5pt'>2</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:8;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>3</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>tirs</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>arr t s</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>par</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>un</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.2pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>gardien</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>de</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt;mso-ansi-language:
  EN-US'>but</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>1</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:9;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>clean</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>sheet</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>:</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span class=SpellE><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>gardien</span></span><span style='font-size:11.5pt;mso-bidi-font-size:
  11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>de</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>but</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>ou</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>d fenseur</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>4</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:10;height:15.85pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>clean</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.2pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>sheet</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>:</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'> <span style='letter-spacing:-.1pt'>un</span><span
  style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>milieu</span><span
  style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
  style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>terrain</span><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>1</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:11;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.9pt;mso-ansi-language:EN-US'> </span><span style='font-size:
  11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>arr t</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>de</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.95pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>p nalty</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt;mso-ansi-language:
  EN-US'>5</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:12;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.7pt;mso-ansi-language:EN-US'> </span><span style='font-size:
  11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:EN-US'>chaque</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>penalty</span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt;mso-ansi-language:
  EN-US'> </span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.2pt;mso-ansi-language:EN-US'>rat </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>2</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:13;height:15.8pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:0in;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>chaque</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.95pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>carton</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>jaune</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.8pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>1</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:14;mso-yfti-lastrow:yes;height:15.85pt'>
  <td width=486 valign=top style='width:364.45pt;border:solid #9E9E9E 1.0pt;
  border-top:none;mso-border-top-alt:solid #9E9E9E .75pt;mso-border-alt:solid #9E9E9E .75pt;
  padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.1pt;margin-bottom:
  0in;margin-left:.9pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>Pour</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>chaque</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-.95pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:
  EN-US'>carton</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>rouge</span><span style='font-size:11.5pt;mso-bidi-font-size:11.0pt;
  font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:
  minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;
  mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=87 valign=top style='width:65.45pt;border-top:none;border-left:
  none;border-bottom:solid #9E9E9E 1.0pt;border-right:solid #9E9E9E 1.0pt;
  mso-border-top-alt:solid #9E9E9E .75pt;mso-border-left-alt:solid #9E9E9E .75pt;
  mso-border-alt:solid #9E9E9E .75pt;padding:0in 0in 0in 0in;height:15.85pt'>
  <p class=TableParagraph style='margin-top:0in;margin-right:.15pt;margin-bottom:
  0in;margin-left:1.0pt;margin-bottom:.0001pt;mso-add-space:auto'><span
  style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>-<span
  style='letter-spacing:-.5pt'>3</span><o:p></o:p></span></p>
  </td>
 </tr>
</table>

</div>

<p class=MsoNormal style='tab-stops:136.25pt'><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoListParagraph style='margin-left:28.3pt;mso-add-space:auto;
text-indent:-17.9pt;mso-list:l8 level2 lfo2;tab-stops:136.25pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;letter-spacing:-.1pt;mso-font-width:92%'><span
style='mso-list:Ignore'>6.2<span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><b style='mso-bidi-font-weight:normal'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Prix</span></b><b style='mso-bidi-font-weight:
normal'><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>m canisme</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gain</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:0in;margin-bottom:0in;
margin-left:30.7pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Football</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>offre</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>prix</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>hebdomadaires</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pendant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>dur e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu.</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<h4 style='margin-top:0in;margin-right:0in;margin-bottom:2.0pt;margin-left:
1.5in;mso-add-space:auto;text-indent:-.25in;mso-list:l4 level3 lfo10'><![if !supportLists]><span
lang=FR style='font-family:Wingdings;mso-fareast-font-family:Wingdings;
mso-bidi-font-family:Wingdings;font-style:normal;mso-bidi-font-style:italic'><span
style='mso-list:Ignore'> <span style='font:7.0pt "Times New Roman"'>&nbsp; </span></span></span><![endif]><span
dir=LTR></span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Prix</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>hebdomadaires</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.35pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'>:</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoListParagraphCxSpFirst style='margin-top:0in;margin-right:56.2pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>Chaque</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>semaine,</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>attribue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>1</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>gagnant</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>un</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>prix</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>de</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>1000</span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.45pt'> </span></b><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'>TND <span class=GramE>TTC<span
style='letter-spacing:-.45pt'> </span><span style='mso-spacerun:yes'> </span><u><span
style='letter-spacing:0pt;font-weight:normal'>par</span></u></span></span></b><u><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'> championnat</span></u><b
style='mso-bidi-font-weight:normal'><span lang=FR style='font-size:11.5pt;
mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.4pt'> (y </span></b><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>compris</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>taxes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toutes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>autres</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> ventuelles</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>taxes</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.5pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>retenue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>source).<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:56.2pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le jeu s  tale sur 12 semaines   raison
de <span class=GramE>deux championnat</span> par semaine. Au total la valeur
des lots cash s  l ve   24 000 DT TTC<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-top:0in;margin-right:33.6pt;
margin-bottom:0in;margin-left:53.45pt;margin-bottom:.0001pt;mso-add-space:auto;
text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.3pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Le</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>total</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>points</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>collect s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tous</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jeux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>jou s</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ou</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l'abonnement</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>actif</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.2pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>au </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>cours<span style='letter-spacing:-.45pt'>
</span>d'une<span style='letter-spacing:-.6pt'> </span>semaine<span
style='letter-spacing:-.6pt'> </span>sp cifique<span style='letter-spacing:
-.6pt'> </span>est<span style='letter-spacing:-.65pt'> </span>pris<span
style='letter-spacing:-.6pt'> </span>en<span style='letter-spacing:-.55pt'> </span>compte<span
style='letter-spacing:-.6pt'> </span>dans<span style='letter-spacing:-.6pt'> </span>le<span
style='letter-spacing:-.6pt'> </span>classement<span style='letter-spacing:
-.8pt'> </span>des </span><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>joueurs</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>dans</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>ligue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>qu il</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>a</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>choisie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l attribution</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Prix</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>hebdomadaire.</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10;tab-stops:100.25pt'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Deux</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Championnats</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.65pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>font</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l objet</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>football</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>fantasy</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.8pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>prix </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>hebdomadaire  </span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>savoir</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ligue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>anglaise</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Premier</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>League</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ligue</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>espagnole</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>La</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'> </span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Liga</span><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Chaque semaine, les points collect s au
cours d'une semaine sp cifique sont r initialis s.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Chaque abonn  peut gagner le Prix
hebdomadaire plusieurs fois pendant la dur e du jeu qui est de 90 jours.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le Prix Hebdomadaire sera attribu  sur
la base du meilleur score entre tous les participants actifs dans le jeu TT
football fantasy. Tous les participants participeront au classement avec le
nombre de points r colt s dans la semaine.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>La semaine est consid r e du lundi <span
class=GramE>00:</span>00:00 heures au dimanche suivant   23:59:59 heures.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>R f rences du jeu Football fantasy : Les
calendriers des championnats de football de premier League Anglais et la Liga
Espagnol.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Une c r monie de remise des lots sera
organis e   une date d finie en commun accord entre Tunisie T l com et <span
class=SpellE>Numbase</span> Tunisie. Aucun lot ne peut  tre distribu  avant la
date de c r monie.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Le gagnant du prix instantan  sera
contact  dans les 48 heures.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>L application de la retenue   la source
de 25% aux montants pay s en Dinars Tunisiens et ceci selon l article 19 de la
loi de finance 2016 mis en vigueur   partir du premier janvier 2016.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>L'organisateur se r serve le droit de
disqualifier tout participant qui semble avoir enfreint l'une des dispositions
des Conditions G n rales.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>Les clients qui participent   Tunisie <span
class=SpellE>telecom</span> football fantasy garantissent par la pr sente que
toutes les informations soumises sont v ridiques,   jour et compl tes les
gagnants  ligibles pour gagner les lots hebdomadaires sont d finis dans
l article 5.<o:p></o:p></span></p>

<p class=MsoListParagraphCxSpMiddle style='margin-left:53.45pt;mso-add-space:
auto;text-indent:-.25in;mso-list:l4 level1 lfo10'><![if !supportLists]><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt'><span
style='mso-list:Ignore'>-<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</span></span></span><![endif]><span dir=LTR></span><span lang=FR
style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'>La liste de classement des
participation<span style='mso-spacerun:yes'>   </span>sera <span class=GramE>effectu <span
style='mso-spacerun:yes'>  </span>par</span> le<span style='mso-spacerun:yes'> 
</span>notaire et un PV de d claration des gagnants sera diffus <span
style='mso-spacerun:yes'>  </span>chaque semaine selon le tableau provisionnel
suivant <o:p></o:p></span></p>

<p class=MsoListParagraphCxSpLast style='margin-left:46.3pt;mso-add-space:auto'><span
lang=FR style='font-size:11.5pt;mso-bidi-font-size:11.0pt;font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></p>

<div align=center>

<table class=TableNormal1 border=1 cellspacing=0 cellpadding=0
 style='border-collapse:collapse;border:none;mso-border-alt:solid black 1.0pt;
 mso-yfti-tbllook:480;mso-padding-alt:0in 0in 0in 0in;mso-border-insideh:1.0pt solid black;
 mso-border-insidev:1.0pt solid black'>
 <tr style='mso-yfti-irow:0;mso-yfti-firstrow:yes;height:14.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Date</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border:solid black 1.0pt;
  border-left:none;mso-border-left-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:29.55pt;
  margin-bottom:0in;margin-left:30.7pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center;text-indent:-.1pt'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Lot </span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Championnat
  Anglais</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border:solid black 1.0pt;
  border-left:none;mso-border-left-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:14.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:51.0pt;
  margin-bottom:0in;margin-left:52.35pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center;text-indent:-.1pt'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt;mso-ansi-language:
  EN-US'>Lot </span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Championnat
  Espagnol</span><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:1;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>1:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>06/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:2;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>2</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>13/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:3;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>3</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>20/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:4;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>4</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>27/10/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:5;height:20.9pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>5:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>03/11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.9pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:6;height:20.6pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>6</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>10//11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.6pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:7;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>7</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>17/11/2025</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;mso-ansi-language:EN-US'><o:p></o:p></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:8;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>8:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.15pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>24/11/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:9;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>9</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>01/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:10;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>10</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.0pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>08/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:11;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>11:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>15/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
 <tr style='mso-yfti-irow:12;mso-yfti-lastrow:yes;height:20.95pt'>
  <td width=162 valign=top style='width:121.2pt;border:solid black 1.0pt;
  border-top:none;mso-border-top-alt:solid black 1.0pt;padding:0in 0in 0in 0in;
  height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.0pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>Semaine</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.1pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>12</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>:</span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-1.05pt;mso-ansi-language:EN-US'> </span><span
  style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
  mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
  minor-latin;letter-spacing:-.1pt;mso-ansi-language:EN-US'>22/12/2025<span
  style='color:#EE0000;background:yellow;mso-highlight:yellow'><o:p></o:p></span></span></p>
  </td>
  <td width=216 valign=top style='width:161.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.15pt;margin-bottom:.0001pt;mso-add-space:
  auto;text-align:center'><span style='font-family:"Aptos",sans-serif;
  mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
  Aptos;mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
  <td width=284 valign=top style='width:212.8pt;border-top:none;border-left:
  none;border-bottom:solid black 1.0pt;border-right:solid black 1.0pt;
  mso-border-top-alt:solid black 1.0pt;mso-border-left-alt:solid black 1.0pt;
  padding:0in 0in 0in 0in;height:20.95pt'>
  <p class=TableParagraph align=center style='margin-top:0in;margin-right:0in;
  margin-bottom:0in;margin-left:5.9pt;margin-bottom:.0001pt;mso-add-space:auto;
  text-align:center'><span style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
  minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
  mso-bidi-theme-font:minor-latin;mso-ansi-language:EN-US'>1000<span
  style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.25pt'>TND</span><o:p></o:p></span></p>
  </td>
 </tr>
</table>

</div>

<h4 style='margin-top:0in;margin-right:32.55pt;margin-bottom:2.0pt;margin-left:
0in;mso-add-space:auto'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black;background:yellow;mso-highlight:
yellow'><o:p>&nbsp;</o:p></span></h4>

<h4 style='margin-top:0in;margin-right:32.55pt;margin-bottom:2.0pt;margin-left:
0in;mso-add-space:auto'><span lang=FR style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;color:black'>NB<span style='letter-spacing:
-1.15pt'> </span>:<span style='letter-spacing:-1.05pt'> </span>Les<span
style='letter-spacing:-1.15pt'> </span>r gles<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-1.2pt'> </span>participation<span
style='letter-spacing:-1.15pt'> </span> <span style='letter-spacing:-1.2pt'> </span>la<span
style='letter-spacing:-1.1pt'> </span>proc dure<span style='letter-spacing:
-1.15pt'> </span>de<span style='letter-spacing:-1.2pt'> </span>s lection<span
style='letter-spacing:-1.05pt'> </span>des<span style='letter-spacing:-1.05pt'>
</span>Gagnants<span style='letter-spacing:-1.15pt'> </span>sont<span
style='letter-spacing:-1.1pt'> </span>les <span style='letter-spacing:-.1pt'>suivantes</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></h4>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Lors</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.75pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>chaque</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>proc dure</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>s lection</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnants,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>principal</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>trois</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.8pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>rempla ants</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>sont<span
style='letter-spacing:-1.2pt'> </span>d sign s<span style='letter-spacing:-1.15pt'>
</span>par<span style='letter-spacing:-1.1pt'> </span>l huissier<span
style='letter-spacing:-1.1pt'> </span>de<span style='letter-spacing:-1.15pt'> </span>justice.<span
style='letter-spacing:-1.15pt'> </span>La<span style='letter-spacing:-1.2pt'> </span>s lection<span
style='letter-spacing:-1.2pt'> </span>se<span style='letter-spacing:-1.15pt'> </span>fait<span
style='letter-spacing:-1.2pt'> </span>parmi<span style='letter-spacing:-1.1pt'>
</span>les<span style='letter-spacing:-1.15pt'> </span>quatre participants<span
style='letter-spacing:-.9pt'> </span>ayant<span style='letter-spacing:-.8pt'> </span>obtenu<span
style='letter-spacing:-.75pt'> </span>les<span style='letter-spacing:-.95pt'> </span>meilleurs<span
style='letter-spacing:-.9pt'> </span>scores<span style='letter-spacing:-.75pt'>
</span>dans<span style='letter-spacing:-.75pt'> </span>chaque<span
style='letter-spacing:-.9pt'> </span>championnat.<span style='letter-spacing:
-.9pt'> </span>Si<span style='letter-spacing:-.8pt'> </span>le<span
style='letter-spacing:-.9pt'> </span>gagnant <span style='letter-spacing:-.2pt'>principal</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>ne</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.2pt'>r pond</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>pas</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>l appel</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>sur</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>sa</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>ligne</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>t l phonique</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>avant</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>13h</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>le</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>jour</span><span
style='letter-spacing:-.9pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.2pt'>s lection,
</span><span style='letter-spacing:-.1pt'>est</span><span style='letter-spacing:
-.95pt'> </span><span style='letter-spacing:-.1pt'>injoignable,</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>refuse</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>prix</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>ou</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>ne</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>se</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>pr sente</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>pas</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>pour</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>le</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>r cup rer</span><span
style='letter-spacing:-1.0pt'> </span><span style='letter-spacing:-.1pt'>dans</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>les</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.1pt'>10</span><span
style='letter-spacing:-.85pt'> </span><span style='letter-spacing:-.1pt'>jours
suivant</span><span style='letter-spacing:-.8pt'> </span><span
style='letter-spacing:-.1pt'>la</span><span style='letter-spacing:-.7pt'> </span><span
style='letter-spacing:-.1pt'>notification</span><span style='letter-spacing:
-.8pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>la</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>seconde</span><span
style='letter-spacing:-.6pt'> </span><span style='letter-spacing:-.1pt'>lettre</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>recommand e,</span><span
style='letter-spacing:-.75pt'> </span><span class=SpellE><span
style='letter-spacing:-.1pt'>Numbase</span></span><span style='letter-spacing:
-.75pt'> </span><span style='letter-spacing:-.1pt'>Tunisie</span><span
style='letter-spacing:-.75pt'> </span><span style='letter-spacing:-.1pt'>contactera</span><span
style='letter-spacing:-.8pt'> </span><span style='letter-spacing:-.1pt'>le
premier</span><span style='letter-spacing:-1.2pt'> </span><span
style='letter-spacing:-.1pt'>rempla ant</span><span style='letter-spacing:-1.2pt'>
</span><span style='letter-spacing:-.1pt'>selon</span><span style='letter-spacing:
-1.1pt'> </span><span style='letter-spacing:-.1pt'>l ordre</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>de</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.1pt'>s lection.</span><span
style='letter-spacing:-1.25pt'> </span><span style='letter-spacing:-.1pt'>Celui-ci</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>sera</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>alors</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>inform </span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>qu il</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.1pt'>a</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.1pt'>remport 
</span>le<span style='letter-spacing:-1.05pt'> </span>prix.<span
style='letter-spacing:-1.15pt'> </span>Si<span style='letter-spacing:-1.2pt'> </span>n cessaire,<span
style='letter-spacing:-1.15pt'> </span>la<span style='letter-spacing:-1.35pt'> </span>proc dure<span
style='letter-spacing:-1.15pt'> </span>se<span style='letter-spacing:-1.15pt'> </span>poursuivra<span
style='letter-spacing:-1.25pt'> </span>avec<span style='letter-spacing:-1.15pt'>
</span>les<span style='letter-spacing:-1.2pt'> </span>autres<span
style='letter-spacing:-1.2pt'> </span>rempla ants<span style='letter-spacing:
-1.15pt'> </span>dans<span style='letter-spacing:-1.15pt'> </span>l ordre <span
style='letter-spacing:-.1pt'> tabli.<o:p></o:p></span></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:31.8pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Les</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>gagnants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>seront</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>contact s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>num ro</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>mobile</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>a</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> t </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>utilis </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participer</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>jeu
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>par<span style='letter-spacing:-.75pt'> </span>SMS.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les<span style='letter-spacing:-.95pt'> </span>participants<span
style='letter-spacing:-.9pt'> </span>sont<span style='letter-spacing:-.95pt'> </span>inform s<span
style='letter-spacing:-.95pt'> </span>que<span style='letter-spacing:-.9pt'> </span>toutes<span
style='letter-spacing:-.95pt'> </span>les<span style='letter-spacing:-.75pt'> </span>donn es<span
style='letter-spacing:-.75pt'> </span>fournies<span style='letter-spacing:-.95pt'>
</span>par<span style='letter-spacing:-.95pt'> </span>leur<span
style='letter-spacing:-.85pt'> </span>soin<span style='letter-spacing:-.85pt'> </span>sont
<span style='letter-spacing:-.2pt'>n cessaires</span><span style='letter-spacing:
-.95pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>prise</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>en</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>compte</span><span
style='letter-spacing:-1.1pt'> </span><span style='letter-spacing:-.2pt'>de</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>leur</span><span
style='letter-spacing:-1.2pt'> </span><span style='letter-spacing:-.2pt'>participation</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>au</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>jeu</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'>et</span><span
style='letter-spacing:-1.15pt'> </span><span style='letter-spacing:-.2pt'> </span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>la</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>dotation</span><span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.2pt'>du</span><span
style='letter-spacing:-.95pt'> </span><span style='letter-spacing:-.2pt'>prix.</span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les<span style='letter-spacing:-1.2pt'> </span>participants<span
style='letter-spacing:-1.15pt'> </span>sont,<span style='letter-spacing:-1.15pt'>
</span>par<span style='letter-spacing:-1.1pt'> </span>cons quent,<span
style='letter-spacing:-1.15pt'> </span>tenus<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>s assurer<span
style='letter-spacing:-1.25pt'> </span>de<span style='letter-spacing:-1.15pt'> </span>la<span
style='letter-spacing:-1.1pt'> </span>validit <span style='letter-spacing:-1.15pt'>
</span>de<span style='letter-spacing:-1.15pt'> </span>ces<span
style='letter-spacing:-1.05pt'> </span>mentions. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:24.1pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Dans</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.25pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>cas</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>o </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>gagnant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mineur,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>celui-ci</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>doit</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>se</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>faire</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>repr senter</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.25pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>parents
ou</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>par</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.0pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>son</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tuteur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l gal</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>apr s</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pr sentation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>acte</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>naissance</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>mineur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>question</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>de<span style='letter-spacing:-.6pt'> </span>la<span
style='letter-spacing:-1.0pt'> </span>CIN<span style='letter-spacing:-.8pt'> </span>du<span
style='letter-spacing:-.75pt'> </span>parent<span style='letter-spacing:-.7pt'>
</span>ou<span style='letter-spacing:-.75pt'> </span>du<span style='letter-spacing:
-.6pt'> </span>tuteur<span style='letter-spacing:-.85pt'> </span>l gal.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.05pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.6pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>participation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>au</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>jeu</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>TT</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Fantasy</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>implique</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.6pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>automatiquement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>l acceptation</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.55pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>par
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>le</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>toutes</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>clauses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>pr sent</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>r glement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>et</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>tous</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ses</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>avenants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>ainsi</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.75pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>que
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>tout</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> l ment</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disponible</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>le</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>site</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>web</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:3.55pt'> </span><span lang=FR><a
href="https://tt.ffeleven.com/"><span style='font-family:"Aptos",sans-serif;
mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:
Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>https://tt.ffeleven.com/</span></a></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:32.55pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>Une</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.9pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>c r monie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>remise</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lots</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>organis e</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>date</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d finie</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>commun</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>accord
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>entre<span style='letter-spacing:-.75pt'> </span><span
class=SpellE>TunisieT l com</span><span style='letter-spacing:-.8pt'> </span>et<span
style='letter-spacing:-.8pt'> </span><span class=SpellE>Numbase</span><span
style='letter-spacing:-.75pt'> </span>Tunisie.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;margin-right:10.4pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>L application</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>d une</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>retenue</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>source</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lib ratoire</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>25%</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>selon</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>l article</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>19</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>loi</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>de
finances</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.1pt'>2016</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.1pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>sur</span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>les</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>lots</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Dinars</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>Tunisiens</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>(1000</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>DT)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>remis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>directement</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.1pt'>aux
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>gagnants<span style='letter-spacing:-.35pt'> </span>relatifs<span
style='letter-spacing:-.35pt'> </span>au<span style='letter-spacing:-.45pt'> </span>pr sent<span
style='letter-spacing:-.3pt'> </span>JEU<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.3pt'>TT</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-1.05pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Football</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>Fantasy,</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>cet</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.3pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>article</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>mis</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.1pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>en</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.15pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>vigueur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>partir</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.2pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>du</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>1er</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>janvier</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.05pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.3pt'>2016.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>ARTICLE<span
style='letter-spacing:-1.05pt'> </span>7<span style='letter-spacing:-1.15pt'> </span>:<span
style='letter-spacing:-1.0pt'> </span>SERVICE<span style='letter-spacing:-1.1pt'>
</span><span style='letter-spacing:-.1pt'>CLIENT<o:p></o:p></span></span></h3>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></h3>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>La</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.85pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Soci t </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Promoteur</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-1.0pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>met</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'> </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>la</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>disposition</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>des</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participants</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.95pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>un</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Service</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.9pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>Client</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>joignable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.25pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>t l phone</span></span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>(1298)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>ou</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>71</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>00</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>1298</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>pour</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.8pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>toute</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>demande</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.85pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>d information.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'>ARTICLE<span
style='letter-spacing:-1.05pt'> </span>8<span style='letter-spacing:-1.2pt'> </span>:<span
style='letter-spacing:-1.05pt'> </span>IDENTIFICATION<span style='letter-spacing:
-1.1pt'> </span>DES<span style='letter-spacing:-1.2pt'> </span>PARTICIPANTS<span
style='letter-spacing:-1.1pt'> </span>ET<span style='letter-spacing:-1.1pt'> </span>DES<span
style='letter-spacing:-1.05pt'> </span><span style='letter-spacing:-.1pt'>GAGNANTS<o:p></o:p></span></span></h3>

<h3 style='margin-top:0in;mso-add-space:auto'><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'><o:p>&nbsp;</o:p></span></h3>

<p class=MsoBodyText style='margin-top:0in;margin-right:38.0pt;margin-bottom:
0in;margin-left:28.3pt;margin-bottom:.0001pt;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.2pt'>Chaque</span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.7pt'>
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>participant</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>sera</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>identifi </span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>par</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>son</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>num ro</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>de</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>portable</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>(MSISDN)</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>qui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>lui</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.65pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>est</span><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin;letter-spacing:-.7pt'> </span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin;letter-spacing:-.2pt'>attribu 
</span><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>lors<span style='letter-spacing:-.95pt'> </span>de<span
style='letter-spacing:-.9pt'> </span>l'achat<span style='letter-spacing:-1.05pt'>
</span>de<span style='letter-spacing:-.9pt'> </span>la<span style='letter-spacing:
-1.05pt'> </span>ligne<span style='letter-spacing:-1.0pt'> </span>GSM.<span
style='letter-spacing:-1.0pt'> </span>Le<span style='letter-spacing:-1.0pt'> </span>contrat<span
style='letter-spacing:-1.05pt'> </span>de<span style='letter-spacing:-1.0pt'> </span>vente<span
style='letter-spacing:-.9pt'> </span> <span style='letter-spacing:-1.05pt'> </span>son<span
style='letter-spacing:-1.05pt'> </span>nom<span style='letter-spacing:-1.05pt'>
</span>et<span style='letter-spacing:-1.05pt'> </span>son<span
style='letter-spacing:-1.05pt'> </span>CIN<span style='letter-spacing:-1.05pt'>
</span>faisant<span style='letter-spacing:-1.05pt'> </span>foi.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les gagnants au jeu SMS sont les abonn s qui seront d sign s par
la proc dure de d signation des gagnants ils devront  tre les propri taires de
la ligne GSM avec laquelle ils ont jou  au JEU TT Football Fantasy.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Si une personne participe au Jeu avec une ligne (un MSISDN) qui
n est pas sa propri t  et que cet MSISDN est s lectionn  comme Gagnant par la
proc dure de d signation des gagnants, cette personne doit, pour b n ficier du
Lot en question, pr senter une procuration  crite du propri taire de la Ligne
(du MSISDN) pour retirer le lot dans un d lai ne d passant pas un mois  
compter de la date de sa s lection.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>ARTICLE 9 : ANNULATION DU JEU<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les soci t s organisatrice et promoteur pourront annuler tout ou
partie du pr sent jeu-<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>concours</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> dans les cas de force majeure ou s il appara t que des fraudes
sont intervenues sous quelque forme que ce soit et notamment de mani re
informatique dans le cadre de la participation au pr sent jeu-concours ou de la
d termination des gagnants.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Elles se r servent, dans cette hypoth se, le droit de ne pas
attribuer les gains aux fraudeurs et/ou de poursuivre devant les juridictions
comp tentes les auteurs de ces fraudes.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>En particulier, sont consid r es comme frauduleuses les m thodes
de participation automatiques au moyen d un logiciel, d un mat riel, d un
automate ou de tout autre dispositif qui ne constitue pas une participation
manuelle.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>On entend par participation manuelle, l envoi d un message par SMS
qui r sulte de l action manuelle d un participant utilisant le clavier d un
t l phone mobile.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>10:</span> D p t du R glement<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le pr sent r glement est d pos  chez Le Notaire, Ma tre <span
class=SpellE>Sadok</span> AL <span class=SpellE>Amdouni</span> dont le cabinet
est Avenue Hedi Chaker, centre <span class=SpellE>Firas</span>, Cit  <span
class=SpellE>Erriadh</span>, La <span class=SpellE>marsa</span> Tunis domicili 
pour ce jeu   caract re fantasy football. Ce r glement sera communiqu 
gratuitement   toute personne faisant la demande aupr s du notaire Ma tre <span
class=SpellE>Sadok</span> AL <span class=SpellE>Amdouni</span>. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les d signations des gagnants sont <span class=GramE>r alis s</span>
sous le contr le de l Huissier de justice, Ma tre Nabil <span class=SpellE>Fakhfakh</span>
dont le cabinet est 9 rue d Autriche 2eme  tage app 12, 1002, belv d re Tunis.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>11:</span> Mode de d claration des
r sultats<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=SpellE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>Numbase</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> Tunisie contactera chaque gagnant par t l phone. Celui-ci sera
invit  au si ge de ladite soci t , ou   lieu d sign  par <span class=SpellE>Numbase</span>
Tunisie pour la c r monie de remise des lots, afin d'obtenir son cadeau. Le
gagnant doit ramener sa carte d'identit  afin de v rifier qu'il est bien le
propri taire de la ligne GSM, et une preuve (Contrat, facture t l phonique,
etc.) prouvant que la ligne (le MSISDN) est le sien, sinon dans le cas  ch ant
une procuration ou un acte de cession du lot en question par le propri taire de
la ligne (de l MSISDN)   l utilisateur de la ligne (de l MSISDN).<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le d lai maximum pour r clamer les lots sera 60 jours   partir de
la date de remise des lots.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Tout gagnant ayant des factures de Tunisie Telecom non pay es ne
peut b n ficier de son gain que suite au r glement de la totalit  de ses dus et
ce dans un d lai ne<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>d passant</span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> pas les 7 jours ouvrables   l annonce. Faute de quoi un autre
gagnant sera<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'>d sign </span></span><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'> selon la proc dure de s lection mentionn  ci-dessus.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>L attribution de tous les lots se fera maximum 45 jours apr s la
fin du jeu<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>12:</span> Exploitation des donn es
personnelles des gagnants<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Chaque participant, s'il devient gagnant, autorise les
organisateurs, ainsi que l'ensemble des soci t s de son groupe,   citer son nom
et ses coordonn es, et   utiliser ses photos, Vid os, d clarations lors de la
remise des lots par tous proc d s et sur tous supports, pendant une dur e de
cinq (5) ans, aux fins de promotion de leurs services respectifs, sans que ceci
lui ouvre d'autre droit, r mun ration ou indemnit  que la remise du prix
attribu .<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>ARTICLE <span class=GramE>13:</span> PROTECTION DES DONN ES
PERSONNELLES<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les informations nominatives recueillies dans le cadre du pr sent
jeu li es   l envoi et   la remise des lots gagn s sont trait es conform ment  
la Loi organique n 2004-63 du 27/07/2004 portant sur la protection des donn es
  caract re personnel.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article 14 : Remboursement<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Dans le cas o  le client demande un remboursement, <span
class=SpellE>Numbase</span> validera la demande et informera TUNISIE T l com en
cons quence. Le co t du SMS pour la participation au jeu peut  tre rembours 
dans la limite <span class=GramE>de un</span> (1) SMS par participant au prix
TTC du SMS. Les demandes de remboursement devront  tre adress es au plus tard
07 jours apr s la date de participation au jeu (le cachet de la poste faisant
foi)<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span
class=GramE><span lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:
minor-latin;mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;
mso-bidi-theme-font:minor-latin'> </span></span><span lang=FR style='font-family:
"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;mso-hansi-theme-font:minor-latin;
mso-bidi-font-family:Aptos;mso-bidi-theme-font:minor-latin'> l'adresse
suivante: Soci t  <span class=SpellE>Numbase</span> TUNISIE.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le timbre sera rembours  au tarif lent en vigueur dans les m mes
conditions  nonc es ci-dessus. Toute demande de remboursement ne contenant pas
les informations ci- dessous ne pourra  tre trait e :<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le nom du jeu ;<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Le num ro SMS concern  (85881) ; L heure et la date des envois des
SMS ;<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Une copie du contrat d abonnement de l op rateur par lequel le SMS
a  t  envoy , Une preuve de paiement, une copie de la facture d taill e et pay 
de l'op rateur de t l communication par lequel le SMS a  t  envoy  ou toute
autre preuve de paiement. <o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Ne seront pas prises en consid ration les demandes de
remboursement dont les coordonn es seront incompl tes, celles adress es apr s
les d lais pr vus ci-dessus, celles ne respectant pas la forme des messages
prescrite   l'article 5 du pr sent r glement ou celles contraires aux
dispositions du pr sent r glement.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><span style='mso-spacerun:yes'> </span><o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>15:</span> Responsabilit <o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les SMS MO et MT qui n'arrivent pas aux participants pendant la
dur e du JEU TT football Fantasy pour quelque raison que ce soit n'entra nent
pas la responsabilit  des organisateurs qui, de bonne foi, s en remettent   la
diligence du r seau.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>TT et l'Organisateur d clinent toute responsabilit  pour, y
compris sans limitation, toute erreur, omission, interruption, d faut, retard
de fonctionnement ou de transmission, d faillance de la ligne de communication
lorsqu'elle n'est pas sous son contr le et son ex cution directs.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>TT et l'Organisateur se r servent le droit, chaque fois que cela
est jug  n cessaire, de suspendre temporairement le jeu <span class=SpellE>TTFootball</span>
Fantasy pour des raisons op rationnelles (par exemple pour des r parations, une
maintenance planifi e ou des mises   niveau). TT et l'Organisateur s'engagent  
r tablir le jeu <span class=SpellE>TTFootball</span> Fantasy dans les meilleurs
d lais apr s toute p riode de suspension temporaire.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>16:</span> Acceptation<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>La participation   ce jeu-concours entra ne l enti re acceptation
des dispositions du pr sent r glement dans leur int gralit , et ce, y compris
d' ventuelles modifications ult rieures ou annulation pouvant  tre rendues
n cessaires, par exemple, en cas de force majeure.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><b><span
lang=FR style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Article <span class=GramE>17:</span> Litige<o:p></o:p></span></b></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'>Les parties s'efforceront de r soudre   l amiable tout litige qui
surviendrait   l occasion de l ex cution du pr sent r glement. En cas de
d saccord d finitif, et sous r serves des dispositions l gales, les tribunaux
de Tunis 1 seront seuls comp tents.<o:p></o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

<p class=MsoBodyText style='margin-top:0in;mso-add-space:auto'><span lang=FR
style='font-family:"Aptos",sans-serif;mso-ascii-theme-font:minor-latin;
mso-hansi-theme-font:minor-latin;mso-bidi-font-family:Aptos;mso-bidi-theme-font:
minor-latin'><o:p>&nbsp;</o:p></span></p>

</div>

</body>

        </html>`  

      }
  }
}
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    detection: {
      order: ['localStorage', 'navigator'],
    },
    interpolation: {
      escapeValue: false,
    },
  });
export default i18n;